var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuerbetLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Symbols",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 275 45",
    style: {
      enableBackground: "new 0 0 275 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#9E9F9E;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#CBCCCB;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFE;}\n\t.st3{fill:#FFFFFE;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#777776;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#777877;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#787977;}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#787978;}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#797978;}\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:#797A79;}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:#7A7B79;}\n\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:#7A7B7A;}\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:#7B7C7B;}\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:#7C7C7B;}\n\t.st14{fill-rule:evenodd;clip-rule:evenodd;fill:#7C7D7C;}\n\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:#7D7E7C;}\n\t.st16{fill-rule:evenodd;clip-rule:evenodd;fill:#7D7E7D;}\n\t.st17{fill-rule:evenodd;clip-rule:evenodd;fill:#7E7F7E;}\n\t.st18{fill-rule:evenodd;clip-rule:evenodd;fill:#7F7F7E;}\n\t.st19{fill-rule:evenodd;clip-rule:evenodd;fill:#7F807F;}\n\t.st20{fill-rule:evenodd;clip-rule:evenodd;fill:#80817F;}\n\t.st21{fill-rule:evenodd;clip-rule:evenodd;fill:#808180;}\n\t.st22{fill-rule:evenodd;clip-rule:evenodd;fill:#818180;}\n\t.st23{fill-rule:evenodd;clip-rule:evenodd;fill:#818281;}\n\t.st24{fill-rule:evenodd;clip-rule:evenodd;fill:#828381;}\n\t.st25{fill-rule:evenodd;clip-rule:evenodd;fill:#828382;}\n\t.st26{fill-rule:evenodd;clip-rule:evenodd;fill:#838483;}\n\t.st27{fill-rule:evenodd;clip-rule:evenodd;fill:#848483;}\n\t.st28{fill-rule:evenodd;clip-rule:evenodd;fill:#848584;}\n\t.st29{fill-rule:evenodd;clip-rule:evenodd;fill:#858684;}\n\t.st30{fill-rule:evenodd;clip-rule:evenodd;fill:#858685;}\n\t.st31{fill-rule:evenodd;clip-rule:evenodd;fill:#868685;}\n\t.st32{fill-rule:evenodd;clip-rule:evenodd;fill:#868786;}\n\t.st33{fill-rule:evenodd;clip-rule:evenodd;fill:#878886;}\n\t.st34{fill-rule:evenodd;clip-rule:evenodd;fill:#878887;}\n\t.st35{fill-rule:evenodd;clip-rule:evenodd;fill:#888988;}\n\t.st36{fill-rule:evenodd;clip-rule:evenodd;fill:#898A88;}\n\t.st37{fill-rule:evenodd;clip-rule:evenodd;fill:#898A89;}\n\t.st38{fill-rule:evenodd;clip-rule:evenodd;fill:#8A8B8A;}\n\t.st39{fill-rule:evenodd;clip-rule:evenodd;fill:#8B8C8A;}\n\t.st40{fill-rule:evenodd;clip-rule:evenodd;fill:#8B8C8B;}\n\t.st41{fill-rule:evenodd;clip-rule:evenodd;fill:#8C8D8C;}\n\t.st42{fill-rule:evenodd;clip-rule:evenodd;fill:#8D8E8C;}\n\t.st43{fill-rule:evenodd;clip-rule:evenodd;fill:#8D8E8D;}\n\t.st44{fill-rule:evenodd;clip-rule:evenodd;fill:#8E8F8E;}\n\t.st45{fill-rule:evenodd;clip-rule:evenodd;fill:#8F908E;}\n\t.st46{fill-rule:evenodd;clip-rule:evenodd;fill:#8F908F;}\n\t.st47{fill-rule:evenodd;clip-rule:evenodd;fill:#90908F;}\n\t.st48{fill-rule:evenodd;clip-rule:evenodd;fill:#909190;}\n\t.st49{fill-rule:evenodd;clip-rule:evenodd;fill:#919290;}\n\t.st50{fill-rule:evenodd;clip-rule:evenodd;fill:#919291;}\n\t.st51{fill-rule:evenodd;clip-rule:evenodd;fill:#929291;}\n\t.st52{fill-rule:evenodd;clip-rule:evenodd;fill:#929392;}\n\t.st53{fill-rule:evenodd;clip-rule:evenodd;fill:#939492;}\n\t.st54{fill-rule:evenodd;clip-rule:evenodd;fill:#939493;}\n\t.st55{fill-rule:evenodd;clip-rule:evenodd;fill:#949593;}\n\t.st56{fill-rule:evenodd;clip-rule:evenodd;fill:#949594;}\n\t.st57{fill-rule:evenodd;clip-rule:evenodd;fill:#959694;}\n\t.st58{fill-rule:evenodd;clip-rule:evenodd;fill:#959695;}\n\t.st59{fill-rule:evenodd;clip-rule:evenodd;fill:#969796;}\n\t.st60{fill-rule:evenodd;clip-rule:evenodd;fill:#979896;}\n\t.st61{fill-rule:evenodd;clip-rule:evenodd;fill:#979897;}\n\t.st62{fill-rule:evenodd;clip-rule:evenodd;fill:#989897;}\n\t.st63{fill-rule:evenodd;clip-rule:evenodd;fill:#989998;}\n\t.st64{fill-rule:evenodd;clip-rule:evenodd;fill:#999A98;}\n\t.st65{fill-rule:evenodd;clip-rule:evenodd;fill:#999A99;}\n\t.st66{fill-rule:evenodd;clip-rule:evenodd;fill:#9A9A99;}\n\t.st67{fill-rule:evenodd;clip-rule:evenodd;fill:#9A9B9A;}\n\t.st68{fill-rule:evenodd;clip-rule:evenodd;fill:#9B9C9B;}\n\t.st69{fill-rule:evenodd;clip-rule:evenodd;fill:#9C9D9B;}\n\t.st70{fill-rule:evenodd;clip-rule:evenodd;fill:#9C9D9C;}\n\t.st71{fill-rule:evenodd;clip-rule:evenodd;fill:#9D9E9D;}\n\t.st72{fill-rule:evenodd;clip-rule:evenodd;fill:#9E9F9D;}\n\t.st73{fill-rule:evenodd;clip-rule:evenodd;fill:#9F9F9E;}\n\t.st74{fill-rule:evenodd;clip-rule:evenodd;fill:#9FA09F;}\n\t.st75{fill-rule:evenodd;clip-rule:evenodd;fill:#A0A1A0;}\n\t.st76{fill-rule:evenodd;clip-rule:evenodd;fill:#A1A2A0;}\n\t.st77{fill-rule:evenodd;clip-rule:evenodd;fill:#A1A2A1;}\n\t.st78{fill-rule:evenodd;clip-rule:evenodd;fill:#A2A3A2;}\n\t.st79{fill-rule:evenodd;clip-rule:evenodd;fill:#A3A4A2;}\n\t.st80{fill-rule:evenodd;clip-rule:evenodd;fill:#A3A4A3;}\n\t.st81{fill-rule:evenodd;clip-rule:evenodd;fill:#A4A4A3;}\n\t.st82{fill-rule:evenodd;clip-rule:evenodd;fill:#A4A5A4;}\n\t.st83{fill-rule:evenodd;clip-rule:evenodd;fill:#A5A6A5;}\n\t.st84{fill-rule:evenodd;clip-rule:evenodd;fill:#A6A7A5;}\n\t.st85{fill-rule:evenodd;clip-rule:evenodd;fill:#A6A7A6;}\n\t.st86{fill-rule:evenodd;clip-rule:evenodd;fill:#A7A8A6;}\n\t.st87{fill-rule:evenodd;clip-rule:evenodd;fill:#A7A8A7;}\n\t.st88{fill-rule:evenodd;clip-rule:evenodd;fill:#A8A8A7;}\n\t.st89{fill-rule:evenodd;clip-rule:evenodd;fill:#A8A9A8;}\n\t.st90{fill-rule:evenodd;clip-rule:evenodd;fill:#A9AAA9;}\n\t.st91{fill-rule:evenodd;clip-rule:evenodd;fill:#AAABA9;}\n\t.st92{fill-rule:evenodd;clip-rule:evenodd;fill:#AAABAA;}\n\t.st93{fill-rule:evenodd;clip-rule:evenodd;fill:#ABABAA;}\n\t.st94{fill-rule:evenodd;clip-rule:evenodd;fill:#ABACAB;}\n\t.st95{fill-rule:evenodd;clip-rule:evenodd;fill:#ACADAC;}\n\t.st96{fill-rule:evenodd;clip-rule:evenodd;fill:#ADAEAC;}\n\t.st97{fill-rule:evenodd;clip-rule:evenodd;fill:#ADAEAD;}\n\t.st98{fill-rule:evenodd;clip-rule:evenodd;fill:#AEAFAD;}\n\t.st99{fill-rule:evenodd;clip-rule:evenodd;fill:#AEAFAE;}\n\t.st100{fill-rule:evenodd;clip-rule:evenodd;fill:#AFAFAE;}\n\t.st101{fill-rule:evenodd;clip-rule:evenodd;fill:#AFB0AF;}\n\t.st102{fill-rule:evenodd;clip-rule:evenodd;fill:#B0B1B0;}\n\t.st103{fill-rule:evenodd;clip-rule:evenodd;fill:#B1B2B0;}\n\t.st104{fill-rule:evenodd;clip-rule:evenodd;fill:#B1B2B1;}\n\t.st105{fill-rule:evenodd;clip-rule:evenodd;fill:#B2B3B1;}\n\t.st106{fill-rule:evenodd;clip-rule:evenodd;fill:#B2B3B2;}\n\t.st107{fill-rule:evenodd;clip-rule:evenodd;fill:#B3B4B3;}\n\t.st108{fill-rule:evenodd;clip-rule:evenodd;fill:#B4B5B4;}\n\t.st109{fill-rule:evenodd;clip-rule:evenodd;fill:#B5B6B4;}\n\t.st110{fill-rule:evenodd;clip-rule:evenodd;fill:#B5B6B5;}\n\t.st111{fill-rule:evenodd;clip-rule:evenodd;fill:#B6B7B5;}\n\t.st112{fill-rule:evenodd;clip-rule:evenodd;fill:#B6B7B6;}\n\t.st113{fill-rule:evenodd;clip-rule:evenodd;fill:#B7B8B7;}\n\t.st114{fill-rule:evenodd;clip-rule:evenodd;fill:#B8B9B8;}\n\t.st115{fill-rule:evenodd;clip-rule:evenodd;fill:#B9BAB8;}\n\t.st116{fill-rule:evenodd;clip-rule:evenodd;fill:#B9BAB9;}\n\t.st117{fill-rule:evenodd;clip-rule:evenodd;fill:#BABBB9;}\n\t.st118{fill-rule:evenodd;clip-rule:evenodd;fill:#BABBBA;}\n\t.st119{fill-rule:evenodd;clip-rule:evenodd;fill:#BBBCBB;}\n\t.st120{fill-rule:evenodd;clip-rule:evenodd;fill:#BCBDBC;}\n\t.st121{fill-rule:evenodd;clip-rule:evenodd;fill:#BDBEBC;}\n\t.st122{fill-rule:evenodd;clip-rule:evenodd;fill:#BDBEBD;}\n\t.st123{fill-rule:evenodd;clip-rule:evenodd;fill:#BEBFBD;}\n\t.st124{fill-rule:evenodd;clip-rule:evenodd;fill:#BEBFBE;}\n\t.st125{fill-rule:evenodd;clip-rule:evenodd;fill:#BFBFBE;}\n\t.st126{fill-rule:evenodd;clip-rule:evenodd;fill:#BFC0BF;}\n\t.st127{fill-rule:evenodd;clip-rule:evenodd;fill:#C0C1C0;}\n\t.st128{fill-rule:evenodd;clip-rule:evenodd;fill:#C1C2C1;}\n\t.st129{fill-rule:evenodd;clip-rule:evenodd;fill:#C2C3C1;}\n\t.st130{fill-rule:evenodd;clip-rule:evenodd;fill:#C2C3C2;}\n\t.st131{fill-rule:evenodd;clip-rule:evenodd;fill:#C3C4C2;}\n\t.st132{fill-rule:evenodd;clip-rule:evenodd;fill:#C3C4C3;}\n\t.st133{fill-rule:evenodd;clip-rule:evenodd;fill:#C4C5C3;}\n\t.st134{fill-rule:evenodd;clip-rule:evenodd;fill:#C4C5C4;}\n\t.st135{fill-rule:evenodd;clip-rule:evenodd;fill:#C5C6C4;}\n\t.st136{fill-rule:evenodd;clip-rule:evenodd;fill:#C5C6C5;}\n\t.st137{fill-rule:evenodd;clip-rule:evenodd;fill:#C6C7C6;}\n\t.st138{fill-rule:evenodd;clip-rule:evenodd;fill:#C7C8C7;}\n\t.st139{fill-rule:evenodd;clip-rule:evenodd;fill:#C8C9C8;}\n\t.st140{fill-rule:evenodd;clip-rule:evenodd;fill:#C9CAC8;}\n\t.st141{fill-rule:evenodd;clip-rule:evenodd;fill:#C9CAC9;}\n\t.st142{fill-rule:evenodd;clip-rule:evenodd;fill:#CACBC9;}\n\t.st143{fill-rule:evenodd;clip-rule:evenodd;fill:#CACBCA;}\n\t.st144{fill-rule:evenodd;clip-rule:evenodd;fill:#CBCCCA;}\n\t.st145{fill-rule:evenodd;clip-rule:evenodd;fill:#CCCDCB;}\n\t.st146{fill-rule:evenodd;clip-rule:evenodd;fill:#CCCDCC;}\n\t.st147{fill-rule:evenodd;clip-rule:evenodd;fill:#CDCDCC;}\n\t.st148{fill-rule:evenodd;clip-rule:evenodd;fill:#CDCECD;}\n\t.st149{fill-rule:evenodd;clip-rule:evenodd;fill:#CECFCE;}\n\t.st150{fill-rule:evenodd;clip-rule:evenodd;fill:#CFD0CF;}\n\t.st151{fill-rule:evenodd;clip-rule:evenodd;fill:#D0D1D0;}\n\t.st152{fill-rule:evenodd;clip-rule:evenodd;fill:#D1D2D0;}\n\t.st153{fill-rule:evenodd;clip-rule:evenodd;fill:#D1D2D1;}\n\t.st154{fill-rule:evenodd;clip-rule:evenodd;fill:#D2D3D1;}\n\t.st155{fill-rule:evenodd;clip-rule:evenodd;fill:#D2D3D2;}\n\t.st156{fill-rule:evenodd;clip-rule:evenodd;fill:#D3D4D2;}\n\t.st157{fill-rule:evenodd;clip-rule:evenodd;fill:#D3D4D3;}\n\t.st158{fill-rule:evenodd;clip-rule:evenodd;fill:#D4D5D3;}\n\t.st159{fill-rule:evenodd;clip-rule:evenodd;fill:#D4D5D4;}\n\t.st160{fill-rule:evenodd;clip-rule:evenodd;fill:#D5D6D4;}\n\t.st161{fill-rule:evenodd;clip-rule:evenodd;fill:#D5D6D5;}\n\t.st162{fill-rule:evenodd;clip-rule:evenodd;fill:#D6D6D5;}\n\t.st163{fill-rule:evenodd;clip-rule:evenodd;fill:#D6D7D6;}\n\t.st164{fill-rule:evenodd;clip-rule:evenodd;fill:#D7D8D6;}\n\t.st165{fill-rule:evenodd;clip-rule:evenodd;fill:#D7D8D7;}\n\t.st166{fill-rule:evenodd;clip-rule:evenodd;fill:#D8D9D7;}\n\t.st167{fill-rule:evenodd;clip-rule:evenodd;fill:#D8D9D8;}\n\t.st168{fill-rule:evenodd;clip-rule:evenodd;fill:#D9DAD8;}\n\t.st169{fill-rule:evenodd;clip-rule:evenodd;fill:#D9DAD9;}\n\t.st170{fill-rule:evenodd;clip-rule:evenodd;fill:#DADBD9;}\n\t.st171{fill-rule:evenodd;clip-rule:evenodd;fill:#DADBDA;}\n\t.st172{fill-rule:evenodd;clip-rule:evenodd;fill:#DBDBDA;}\n\t.st173{fill-rule:evenodd;clip-rule:evenodd;fill:#DBDCDB;}\n\t.st174{fill-rule:evenodd;clip-rule:evenodd;fill:#DCDDDC;}\n\t.st175{fill-rule:evenodd;clip-rule:evenodd;fill:#DDDEDD;}\n\t.st176{fill-rule:evenodd;clip-rule:evenodd;fill:#DEDEDD;}\n\t.st177{fill-rule:evenodd;clip-rule:evenodd;fill:#DEDFDE;}\n\t.st178{fill-rule:evenodd;clip-rule:evenodd;fill:#DFDFDE;}\n\t.st179{fill-rule:evenodd;clip-rule:evenodd;fill:#DFE0DF;}\n\t.st180{fill-rule:evenodd;clip-rule:evenodd;fill:#E0E1DF;}\n\t.st181{fill-rule:evenodd;clip-rule:evenodd;fill:#E0E1E0;}\n\t.st182{fill-rule:evenodd;clip-rule:evenodd;fill:#E1E2E0;}\n\t.st183{fill-rule:evenodd;clip-rule:evenodd;fill:#E1E2E1;}\n\t.st184{fill-rule:evenodd;clip-rule:evenodd;fill:#E2E3E1;}\n\t.st185{fill-rule:evenodd;clip-rule:evenodd;fill:#E3E3E2;}\n\t.st186{fill-rule:evenodd;clip-rule:evenodd;fill:#E3E4E2;}\n\t.st187{fill-rule:evenodd;clip-rule:evenodd;fill:#E4E4E3;}\n\t.st188{fill-rule:evenodd;clip-rule:evenodd;fill:#E4E5E4;}\n\t.st189{fill-rule:evenodd;clip-rule:evenodd;fill:#E5E5E4;}\n\t.st190{fill-rule:evenodd;clip-rule:evenodd;fill:#E5E6E5;}\n\t.st191{fill-rule:evenodd;clip-rule:evenodd;fill:#E6E6E5;}\n\t.st192{fill-rule:evenodd;clip-rule:evenodd;fill:#E7E7E6;}\n\t.st193{fill-rule:evenodd;clip-rule:evenodd;fill:#E8E8E7;}\n\t.st194{fill-rule:evenodd;clip-rule:evenodd;fill:#E9E9E8;}\n\t.st195{fill-rule:evenodd;clip-rule:evenodd;fill:#EAEAE9;}\n\t.st196{fill-rule:evenodd;clip-rule:evenodd;fill:#EBEAE9;}\n\t.st197{fill-rule:evenodd;clip-rule:evenodd;fill:#EBEBEA;}\n\t.st198{fill-rule:evenodd;clip-rule:evenodd;fill:#ECECEB;}\n\t.st199{fill-rule:evenodd;clip-rule:evenodd;fill:#EDEDEC;}\n\t.st200{fill-rule:evenodd;clip-rule:evenodd;fill:#EEEEED;}\n\t.st201{fill-rule:evenodd;clip-rule:evenodd;fill:#EFEEED;}\n\t.st202{fill-rule:evenodd;clip-rule:evenodd;fill:#EFEFEE;}\n\t.st203{fill-rule:evenodd;clip-rule:evenodd;fill:#F0EFEE;}\n\t.st204{fill-rule:evenodd;clip-rule:evenodd;fill:#F0F0EF;}\n\t.st205{fill-rule:evenodd;clip-rule:evenodd;fill:#F1F0EF;}\n\t.st206{fill-rule:evenodd;clip-rule:evenodd;fill:#F1F1F0;}\n\t.st207{fill-rule:evenodd;clip-rule:evenodd;fill:#F2F1F0;}\n\t.st208{fill-rule:evenodd;clip-rule:evenodd;fill:#F3F2F1;}\n\t.st209{fill-rule:evenodd;clip-rule:evenodd;fill:#F3F2F2;}\n\t.st210{fill-rule:evenodd;clip-rule:evenodd;fill:#F4F3F2;}\n\t.st211{fill-rule:evenodd;clip-rule:evenodd;fill:#F4F3F3;}\n\t.st212{fill-rule:evenodd;clip-rule:evenodd;fill:#F5F4F3;}\n\t.st213{fill-rule:evenodd;clip-rule:evenodd;fill:#F5F5F4;}\n\t.st214{fill-rule:evenodd;clip-rule:evenodd;fill:#F6F5F4;}\n\t.st215{fill-rule:evenodd;clip-rule:evenodd;fill:#F7F6F5;}\n\t.st216{fill-rule:evenodd;clip-rule:evenodd;fill:#F8F7F6;}\n\t.st217{fill-rule:evenodd;clip-rule:evenodd;fill:#F9F8F7;}\n\t.st218{fill-rule:evenodd;clip-rule:evenodd;fill:#FAF9F8;}\n\t.st219{fill-rule:evenodd;clip-rule:evenodd;fill:#FBF9F9;}\n\t.st220{fill-rule:evenodd;clip-rule:evenodd;fill:#FBFAF9;}\n\t.st221{fill-rule:evenodd;clip-rule:evenodd;fill:#FCFAFA;}\n\t.st222{fill-rule:evenodd;clip-rule:evenodd;fill:#FCFBFA;}\n\t.st223{fill-rule:evenodd;clip-rule:evenodd;fill:#FDFBFB;}\n\t.st224{fill-rule:evenodd;clip-rule:evenodd;fill:#FDFCFB;}\n\t.st225{fill-rule:evenodd;clip-rule:evenodd;fill:#FEFDFC;}\n\t.st226{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFDFC;}\n\t.st227{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFEFD;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_white",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M244.3,10.2c0,1-0.8,1.9-1.8,1.9h-0.1h-8c-1,0-1.9-0.8-1.9-1.8v-0.1V1.9c0-1,0.8-1.9,1.8-1.9h0.1 h8c1,0,1.9,0.8,1.9,1.8v0.1V10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    className: "st1",
    d: "M259.7,10.2c0,1-0.8,1.9-1.8,1.9h-0.1h-8.3c-1,0-1.9-0.8-1.9-1.8v-0.1V1.9c0-1,0.8-1.9,1.8-1.9 h0.1h8c1,0,1.9,0.8,1.9,1.8v0.1v8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st0",
    d: "M244.3,26.2c0,1-0.8,1.9-1.8,1.9h-0.1h-8c-1,0-1.9-0.8-1.9-1.8v-0.1v-8.3c0-1,0.8-1.9,1.8-1.9h0.1 h8c1,0,1.9,0.8,1.9,1.8v0.1V26.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "st1",
    d: "M259.7,26.2c0,1-0.8,1.9-1.8,1.9h-0.1h-8.3c-1,0-1.9-0.8-1.9-1.8v-0.1v-8.3c0-1,0.8-1.9,1.8-1.9 h0.1h8c1,0,1.9,0.8,1.9,1.8v0.1v8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    className: "st2",
    d: "M274.9,26.2c0,1-0.8,1.9-1.8,1.9H273h-8c-1,0-1.9-0.8-1.9-1.8v-0.1v-8.3c0-1,0.8-1.9,1.8-1.9h0.1 h8c1,0,1.9,0.8,1.9,1.8v0.1V26.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "st0",
    d: "M244.3,42.2c0,1-0.8,1.9-1.8,1.9h-0.1h-8c-1,0-1.9-0.8-1.9-1.8v-0.1V34c0-1,0.8-1.9,1.8-1.9h0.1h8 c1,0,1.9,0.8,1.9,1.8V34V42.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    className: "st1",
    d: "M259.7,42.2c0,1-0.8,1.9-1.8,1.9h-0.1h-8.3c-1,0-1.9-0.8-1.9-1.8v-0.1V34c0-1,0.8-1.9,1.8-1.9h0.1 h8c1,0,1.9,0.8,1.9,1.8V34v8.3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-8",
    transform: "translate(263.06 32.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    className: "st2",
    d: "M11.9,10.2c0,1-0.8,1.9-1.8,1.9H10H2c-1,0-1.9-0.8-1.9-1.8v-0.1V1.9C0,0.9,0.8,0,1.8,0h0.1h8 c1,0,1.9,0.8,1.9,1.8v0.1L11.9,10.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    className: "st2",
    d: "M27.6,39.2c-3,3.3-7.4,5.1-11.9,5c-4.3,0-8.3-1.7-11.3-4.7C0,35.3,0,30.4,0,22.1 S0,8.8,4.1,4.7C7.2,1.6,11.4-0.1,15.7,0c9.1,0,14.6,6.1,15.7,13.5h-6.6c-1.1-4.7-4.4-7.7-9.1-7.7c-2.4,0-4.7,1-6.3,2.8 C7.2,11,6.6,13.3,6.6,22.1s0.6,11.3,2.5,13.5c1.7,1.7,3.9,2.7,6.3,2.8c2.7,0,5.3-1.1,7.2-3c1.6-1.9,2.4-4.4,2.2-6.9V26h-9.1v-5.5 h15.7v6.6C31.5,32.6,30.4,36.2,27.6,39.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-11",
    transform: "translate(35.608 12.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    className: "st2",
    d: "M19,30.9v-3c-4.3,4.4-11.3,4.8-16,0.8c-2.5-2.2-3-5.2-3-8.8V0h6.3v18.8c0,4.7,2.8,6.9,6.3,6.9 s6.3-2.2,6.3-6.9V0h6.4v30.9H19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-12",
    transform: "translate(64.316 12.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    className: "st2",
    d: "M6.1,17.4c0,5.2,2.8,8.6,7.7,8.6c3.6,0,5.2-1.1,7.5-3l3.9,3.6c-2.8,3.3-5.8,5-11.3,5 C6.1,31.5,0,27.3,0,15.7C0,5.8,5.2,0,13.3,0c8.3,0,13.2,6.1,13.2,14.9v2.8H6.1V17.4z M19.3,8.8c-1.1-2.4-3.5-3.9-6.1-3.9 c-2.6-0.1-5.1,1.4-6.1,3.9c-0.6,1.3-0.9,2.7-0.8,4.1h13.8C20.2,11.6,19.9,10.1,19.3,8.8L19.3,8.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-13",
    transform: "translate(94.127 12.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    className: "st2",
    d: "M17.1,7.5c-1.4-1.4-2.5-2.2-4.7-2.2c-3.3,0-6.1,2.8-6.1,6.9V31H0V0.3h6.1v3.3 C7.7,1.4,10.8,0,14.4,0c2.8-0.1,5.5,1,7.5,3L17.1,7.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-14",
    transform: "translate(116.486 0.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    className: "st2",
    d: "M21.8,41.1c-2,1.8-4.7,2.8-7.5,2.8c-3.2,0.2-6.2-1.1-8.3-3.6v3.3H0V0h6.1v15.7 c2.2-2.8,4.7-3.6,8-3.6c2.7-0.1,5.4,0.9,7.5,2.8c3,3,3.6,8.3,3.6,13C25.1,32.8,24.8,38.1,21.8,41.1z M12.7,17.7 c-5.5,0-6.3,4.7-6.3,10.2s0.8,10.2,6.3,10.2S19,33.4,19,27.9C19,22.6,18.2,17.7,12.7,17.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-15",
    transform: "translate(143.813 12.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    className: "st2",
    d: "M6.3,17.7c0,5.2,2.8,8.6,7.7,8.6c3.6,0,5.2-1.1,7.5-3l3.9,3.6c-3,3-6.1,4.7-11.6,4.7 C6.1,31.5,0,27.3,0,15.7C0,5.8,5.2,0,13.2,0c8.3,0,13.2,6.1,13.2,14.9v2.8C26.4,17.7,6.3,17.7,6.3,17.7z M19.3,9.1 c-1.1-2.4-3.5-3.9-6.1-3.9c-2.6-0.1-5.1,1.4-6.1,3.9c-0.6,1.3-0.8,2.7-0.8,4.1h13.8C20.2,11.8,19.9,10.4,19.3,9.1L19.3,9.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    className: "st2",
    d: "M183,43.9c-5.8,0-8.6-4.1-8.6-8.6V18.2h-3.6v-4.7h3.6V4.1h6.3v9.4h6.1v4.7h-6.1V35 c0,2.2,1.1,3.6,3.3,3.6h2.5v5.2H183"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-18",
    className: "st3",
    d: "M207.9,0h4.4v43.9h-4.4V0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-20",
    className: "st4",
    d: "M274.9,10.2c0,1-0.8,1.9-1.8,1.9H273h-8c-1,0-1.9-0.8-1.9-1.8v-0.1V1.9c0-1,0.8-1.9,1.8-1.9h0.1 h8c1,0,1.9,0.8,1.9,1.8v0.1V10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    className: "st5",
    d: "M263.1,10.2V1.9c0-1,0.8-1.9,1.8-1.9h0.1h8c1,0,1.9,0.8,1.9,1.8v0.1v8.3c0,1-0.8,1.9-1.8,1.9H273 h-8C263.9,12.2,263.1,11.3,263.1,10.2C263.1,10.3,263.1,10.2,263.1,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    className: "st5",
    d: "M263.1,10.2V1.9c0-1,0.8-1.9,1.8-1.9h0.1h8c1,0,1.9,0.8,1.9,1.8v0.1v8.3c0,1-0.8,1.9-1.8,1.9H273 h-8C263.9,12.2,263.1,11.3,263.1,10.2C263.1,10.3,263.1,10.2,263.1,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-23",
    className: "st6",
    d: "M263.1,10.2V1.9c0-1,0.8-1.9,1.8-1.9h0.1h8c1,0,1.9,0.8,1.9,1.8v0.1v8.3c0,1-0.8,1.9-1.8,1.9H273 h-8C263.9,12.2,263.1,11.3,263.1,10.2C263.1,10.3,263.1,10.2,263.1,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-24",
    className: "st7",
    d: "M263.1,10.2V1.9c0-1,0.8-1.9,1.8-1.9h0.1h8c1,0,1.9,0.8,1.9,1.8v0.1v8.3c0,1-0.8,1.9-1.8,1.9H273 h-8C263.9,12.2,263.1,11.3,263.1,10.2C263.1,10.3,263.1,10.2,263.1,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    className: "st8",
    d: "M263.1,10.2v-8c0-1,0.8-1.9,1.8-1.9h0.1h8c1,0,1.9,0.8,1.9,1.8v0.1v8c0,1-0.8,1.9-1.8,1.9H273h-8 C263.9,12.2,263.1,11.3,263.1,10.2C263.1,10.3,263.1,10.2,263.1,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-26",
    className: "st9",
    d: "M263.1,10.2v-8c0-1,0.8-1.9,1.8-1.9h0.1h8c1,0,1.9,0.8,1.9,1.8v0.1v8c0,1-0.8,1.9-1.8,1.9H273h-8 C263.9,12.2,263.1,11.3,263.1,10.2C263.1,10.3,263.1,10.2,263.1,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-27",
    className: "st9",
    d: "M263.1,10.2v-8c0-1,0.8-1.9,1.8-1.9h0.1h8c1,0,1.9,0.8,1.9,1.8v0.1v8c0,1-0.8,1.9-1.8,1.9H273h-8 C263.9,12.2,263.1,11.3,263.1,10.2C263.1,10.3,263.1,10.2,263.1,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-28",
    className: "st10",
    d: "M263.1,10.2v-8c0-1,0.8-1.9,1.8-1.9h0.1h7.7c1,0,1.9,0.8,1.9,1.8v0.1v8c0,1-0.8,1.9-1.8,1.9 h-0.1H265C263.9,12.2,263.1,11.3,263.1,10.2C263.1,10.3,263.1,10.2,263.1,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-29",
    className: "st11",
    d: "M263.1,10.2v-8c0-1,0.8-1.9,1.8-1.9h0.1h7.7c1,0,1.9,0.8,1.9,1.8v0.1v8c0,1-0.8,1.9-1.8,1.9 h-0.1H265C263.9,12.2,263.1,11.3,263.1,10.2C263.1,10.3,263.1,10.2,263.1,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-30",
    className: "st11",
    d: "M263.1,10.2v-8c0-1,0.8-1.9,1.8-1.9h0.1h7.7c1,0,1.9,0.8,1.9,1.8v0.1v8c0,1-0.8,1.9-1.8,1.9 h-0.1H265C264,12,263.2,11.2,263.1,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-31",
    className: "st12",
    d: "M263.1,10.2v-8c0-1,0.8-1.9,1.8-1.9h0.1h7.7c1,0,1.9,0.8,1.9,1.8v0.1v8c0,1-0.8,1.9-1.8,1.9 h-0.1H265C264,12,263.2,11.2,263.1,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-32",
    className: "st12",
    d: "M263.1,10.2v-8c0-1,0.8-1.9,1.8-1.9h0.1h7.7c1,0,1.9,0.8,1.9,1.8v0.1v8c0,1-0.8,1.9-1.8,1.9 h-0.1H265C264,12,263.2,11.2,263.1,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-33",
    className: "st13",
    d: "M263.1,10.2v-8c0-1,0.8-1.9,1.8-1.9h0.1h7.7c1,0,1.9,0.8,1.9,1.8v0.1v8c0,1-0.8,1.9-1.8,1.9 h-0.1H265C264,12,263.2,11.2,263.1,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-34",
    className: "st14",
    d: "M263.1,10.2V2.5c0-1,0.8-1.9,1.8-1.9h0.1h7.7c1,0,1.9,0.8,1.9,1.8v0.1v7.7c0,1-0.8,1.9-1.8,1.9 h-0.1H265C264.2,11.9,263.1,11,263.1,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-35",
    className: "st14",
    d: "M263.1,10.2V2.5c0-1,0.8-1.9,1.8-1.9h0.1h7.7c1,0,1.9,0.8,1.9,1.8v0.1v7.7c0,1-0.8,1.9-1.8,1.9 h-0.1H265C264.2,11.9,263.1,11,263.1,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-36",
    className: "st15",
    d: "M263.3,9.9V2.2c0-1,0.8-1.9,1.8-1.9h0.1h7.7c1,0,1.9,0.8,1.9,1.8v0.1v7.7c0,1-0.8,1.9-1.8,1.9 h-0.1h-7.7C264.2,11.9,263.4,11.1,263.3,9.9C263.3,10,263.3,10,263.3,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-37",
    className: "st16",
    d: "M263.3,9.9V2.2c0-1,0.8-1.9,1.8-1.9h0.1h7.7c1-0.1,1.8,0.7,1.9,1.7v7.7c0,1-0.8,1.9-1.8,1.9 h-0.1h-7.7c-0.8,0.2-1.7-0.3-1.9-1.1C263.3,10.3,263.3,10.1,263.3,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-38",
    className: "st16",
    d: "M263.3,9.9V2.2c0-1,0.8-1.9,1.8-1.9h0.1h7.7c1-0.1,1.8,0.7,1.9,1.7v7.7c0,1-0.8,1.9-1.8,1.9 h-0.1h-7.7c-0.8,0.2-1.7-0.3-1.9-1.1C263.3,10.3,263.3,10.1,263.3,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-39",
    className: "st17",
    d: "M263.3,9.9V2.2c0-1.1,0.8-1.7,1.9-1.9h7.7c1-0.1,1.8,0.7,1.9,1.7v7.7c0,1.1-0.8,1.7-1.9,1.9 h-7.5c-0.9,0.3-1.8-0.2-2.1-1C263.4,10.3,263.3,10.1,263.3,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-40",
    className: "st17",
    d: "M263.3,9.9V2.2c0-1.1,0.8-1.7,1.9-1.7h7.5c1-0.1,1.8,0.7,1.9,1.7v7.7c0,1.1-0.8,1.7-1.9,1.7 h-7.5c-0.8,0.2-1.7-0.3-1.9-1.1C263.3,10.3,263.3,10.1,263.3,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-41",
    className: "st18",
    d: "M263.3,9.9V2.2c0-1.1,0.8-1.7,1.9-1.7h7.5c1-0.1,1.8,0.7,1.9,1.7v7.7c0,1.1-0.8,1.7-1.9,1.7 h-7.5c-0.8,0.2-1.7-0.3-1.9-1.1C263.3,10.3,263.3,10.1,263.3,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-42",
    className: "st19",
    d: "M263.3,9.9V2.2c0-1.1,0.8-1.7,1.9-1.7h7.5c1-0.1,1.8,0.7,1.9,1.7v7.7c0,1.1-0.8,1.7-1.9,1.7 h-7.5c-0.8,0.2-1.7-0.3-1.9-1.1C263.3,10.3,263.3,10.1,263.3,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-43",
    className: "st19",
    d: "M263.3,9.9V2.5c0-1.1,0.8-1.7,1.9-1.7h7.5c1-0.1,1.8,0.7,1.9,1.7V10c0,1.1-0.8,1.7-1.9,1.7h-7.5 C264.2,11.6,263.3,11,263.3,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-44",
    className: "st20",
    d: "M263.3,9.9V2.5c0-1.1,0.8-1.7,1.9-1.7h7.5c1-0.1,1.8,0.7,1.9,1.7V10c0,1.1-0.8,1.7-1.9,1.7h-7.5 C264.2,11.6,263.3,11,263.3,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-45",
    className: "st21",
    d: "M263.3,9.9V2.5c0-1.1,0.8-1.7,1.9-1.7h7.5c1-0.1,1.8,0.7,1.9,1.7V10c-0.1,1-0.9,1.7-1.9,1.7 h-7.5C264.3,11.6,263.4,10.9,263.3,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-46",
    className: "st22",
    d: "M263.3,9.9V2.5c0.1-1,0.9-1.7,1.9-1.7h7.5c1-0.1,1.8,0.7,1.9,1.7V10c-0.1,1-0.9,1.7-1.9,1.7 h-7.5C264.3,11.6,263.4,10.9,263.3,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-47",
    className: "st23",
    d: "M263.3,9.9V2.5c0.1-1,0.9-1.7,1.9-1.7h7.5c1-0.1,1.8,0.7,1.9,1.7V10c-0.1,1-0.9,1.7-1.9,1.7 h-7.5C264.3,11.6,263.4,10.9,263.3,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-48",
    className: "st23",
    d: "M263.3,9.9V2.5c0.1-1,0.9-1.7,1.9-1.7h7.5c1-0.1,1.8,0.7,1.9,1.7V10c-0.1,1-0.9,1.7-1.9,1.7 h-7.5C264.3,11.6,263.4,10.9,263.3,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-49",
    className: "st24",
    d: "M263.3,9.9V2.5c0.1-1,0.9-1.7,1.9-1.7h7.5c1-0.1,1.8,0.7,1.9,1.7V10c-0.1,1-0.9,1.7-1.9,1.7 h-7.5C264.3,11.6,263.4,10.9,263.3,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-50",
    className: "st25",
    d: "M263.3,9.9V2.5c0.1-1,0.9-1.7,1.9-1.7h7.5c1-0.1,1.8,0.7,1.9,1.7V10c-0.1,1-0.9,1.7-1.9,1.7 h-7.5C264.3,11.6,263.4,10.9,263.3,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-51",
    className: "st25",
    d: "M263.3,9.9V2.5c0.1-1,0.9-1.7,1.9-1.7h7.2c1-0.1,1.8,0.7,1.9,1.7V10c-0.1,1-0.9,1.7-1.9,1.7 h-7.2C264.3,11.6,263.4,10.9,263.3,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-52",
    className: "st26",
    d: "M263.6,9.9V2.8c0.1-1,0.9-1.7,1.9-1.7h7.2c1-0.1,1.8,0.7,1.9,1.7V10c-0.1,1-0.9,1.7-1.9,1.7 h-7.2C264.2,11.6,263.6,10.8,263.6,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-53",
    className: "st26",
    d: "M263.6,9.9V2.8c0.1-1,0.9-1.7,1.9-1.7h7.2c1-0.1,1.8,0.7,1.9,1.7V10c-0.1,1-0.9,1.7-1.9,1.7 h-7.2C264.6,11.6,263.7,10.9,263.6,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-54",
    className: "st27",
    d: "M263.6,9.9V2.8c0.1-1,0.9-1.7,1.9-1.7h7.2c1-0.1,1.8,0.7,1.9,1.7V10c-0.1,1-0.9,1.7-1.9,1.7 h-7.2C264.6,11.6,263.7,10.9,263.6,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-55",
    className: "st28",
    d: "M263.6,9.9V2.8c0.1-1,0.9-1.7,1.9-1.7h7.2c0.9,0,1.6,0.6,1.7,1.5v0.1v7.2 c-0.1,1-0.9,1.7-1.9,1.7h-7.2C264.4,11.5,263.7,10.8,263.6,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-56",
    className: "st28",
    d: "M263.6,9.7V2.5c0.1-1,0.9-1.7,1.9-1.7h7.2c0.9,0,1.6,0.6,1.7,1.5v0.1v7.2 c-0.1,1-0.9,1.7-1.9,1.7h-7.2C264.4,11.3,263.7,10.7,263.6,9.7C263.6,9.7,263.6,9.7,263.6,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-57",
    className: "st29",
    d: "M263.6,9.7V2.5c0.1-1,0.9-1.7,1.9-1.7h7.2c0.9,0,1.6,0.6,1.7,1.5v0.1v7.2 c-0.1,1-0.9,1.7-1.9,1.7h-7.2C264.4,11.3,263.7,10.7,263.6,9.7C263.6,9.7,263.6,9.7,263.6,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-58",
    className: "st30",
    d: "M263.6,9.7V2.5c0.1-1,0.9-1.7,1.9-1.7h7.2c0.9,0,1.6,0.6,1.7,1.5v0.1v7.2 c-0.1,1-0.9,1.7-1.9,1.7h-7.2C264.4,11.3,263.7,10.7,263.6,9.7C263.6,9.7,263.6,9.7,263.6,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-59",
    className: "st31",
    d: "M263.6,9.7V2.5c0.1-0.9,0.8-1.6,1.7-1.7h7.2c0.9,0,1.6,0.6,1.7,1.5v0.1v7.2 c-0.1,1-0.9,1.7-1.9,1.7H265C264.2,11.2,263.6,10.5,263.6,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-60",
    className: "st32",
    d: "M263.6,9.7V2.5c0.1-0.9,0.8-1.6,1.7-1.7h7.2c0.9,0,1.6,0.6,1.7,1.5v0.1v7.2 c-0.1,0.9-0.8,1.6-1.7,1.7h-7.2C264.4,11.3,263.7,10.7,263.6,9.7C263.6,9.7,263.6,9.7,263.6,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-61",
    className: "st32",
    d: "M263.6,9.7V2.8c0.1-0.9,0.8-1.6,1.7-1.7h7.2c0.9,0,1.6,0.6,1.7,1.5v0.1v6.9 c-0.1,0.9-0.8,1.6-1.7,1.7h-7.2C264.4,11.3,263.7,10.5,263.6,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-62",
    className: "st33",
    d: "M263.6,9.7V2.8c0.1-0.9,0.8-1.6,1.7-1.7h6.9c0.9,0.1,1.6,0.8,1.7,1.7v6.9 c-0.1,0.9-0.8,1.6-1.7,1.7h-6.9C264.4,11.3,263.7,10.5,263.6,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-63",
    className: "st34",
    d: "M263.6,9.7V2.8c0.1-0.9,0.8-1.6,1.7-1.7h6.9c0.9,0.1,1.6,0.8,1.7,1.7v6.9 c-0.1,0.9-0.8,1.6-1.7,1.7h-6.9C264.4,11.3,263.7,10.5,263.6,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-64",
    className: "st34",
    d: "M263.6,9.7V2.8c0.1-0.9,0.8-1.6,1.7-1.7h6.9c0.9,0.1,1.6,0.8,1.7,1.7v6.9 c-0.1,0.9-0.8,1.6-1.7,1.7h-6.9C264.4,11.3,263.7,10.5,263.6,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-65",
    className: "st35",
    d: "M263.6,9.7V2.8c0.1-0.9,0.8-1.6,1.7-1.7h6.9c1.4,0,2.2,0.6,2.2,1.7v6.9 c-0.1,0.9-0.8,1.6-1.7,1.7h-6.9C264.4,11.3,263.6,10.5,263.6,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-66",
    className: "st35",
    d: "M263.6,9.7V2.8c0.1-0.9,0.8-1.6,1.7-1.7h6.9c1.4,0,2.2,0.6,2.2,1.7v6.9 c-0.1,0.9-0.8,1.6-1.7,1.7h-6.9C264.4,11.3,263.6,10.5,263.6,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-67",
    className: "st36",
    d: "M263.6,9.7c0,0,0-6.9,0.3-6.9c0.1-0.9,0.8-1.6,1.7-1.7h6.9c0.9,0.1,1.6,0.8,1.7,1.7 c0,0,0,6.9-0.3,6.9c-0.1,0.9-0.8,1.6-1.7,1.7h-6.9C264.4,11.3,263.7,10.5,263.6,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-68",
    className: "st37",
    d: "M263.9,9.7c0,0,0-6.9,0.3-6.9c0.1-0.9,0.8-1.6,1.7-1.7h6.9c0.9,0,1.6,0.6,1.7,1.5v0.1 c0,0,0,6.9-0.3,6.9c-0.1,0.9-0.8,1.6-1.7,1.7h-6.9C264.7,11.3,264,10.7,263.9,9.7C263.9,9.7,263.9,9.7,263.9,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-69",
    className: "st37",
    d: "M263.9,9.7c0,0,0-6.9,0.3-6.9c0.1-0.9,0.8-1.6,1.7-1.7h6.9c0.9,0,1.6,0.6,1.7,1.5v0.1 c0,0,0,6.9-0.3,6.9c-0.1,0.9-0.8,1.6-1.7,1.7h-6.9C264.7,11.3,264,10.7,263.9,9.7C263.9,9.7,263.9,9.7,263.9,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-70",
    className: "st38",
    d: "M263.9,9.7c0,0,0-6.6,0.3-6.6c0.1-0.9,0.8-1.6,1.7-1.7h6.9c0.9,0,1.6,0.6,1.7,1.5V3 c0,0,0,6.6-0.3,6.6c-0.1,0.9-0.8,1.6-1.7,1.7h-6.9C264.4,11,263.9,10.5,263.9,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-71",
    className: "st38",
    d: "M263.9,9.7c0,0,0-6.6,0.3-6.6c0.1-0.9,0.8-1.6,1.7-1.7h6.9c0.9,0,1.6,0.6,1.7,1.5V3 c0,0,0,6.6-0.3,6.6c-0.1,0.9-0.8,1.6-1.7,1.7h-6.9C264.4,11,263.9,10.5,263.9,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-72",
    className: "st39",
    d: "M263.9,9.7c0,0,0-6.6,0.3-6.6c0.1-0.9,0.8-1.6,1.7-1.7h6.9c0.9,0,1.6,0.6,1.7,1.5V3 c0,0,0,6.6-0.3,6.6c-0.1,0.9-0.8,1.6-1.7,1.7h-6.9C264.4,11,263.9,10.5,263.9,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-73",
    className: "st40",
    d: "M263.9,9.7c0,0,0-6.6,0.3-6.6c0.1-0.9,0.8-1.6,1.7-1.7h6.6c0.9,0,1.6,0.6,1.7,1.5V3 c0,0,0,6.6-0.3,6.6c-0.1,0.9-0.8,1.6-1.7,1.7h-6.6C264.7,11,263.9,10.5,263.9,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-74",
    className: "st40",
    d: "M263.9,9.7c0,0,0-6.6,0.3-6.6c0.1-0.9,0.8-1.6,1.7-1.7h6.6c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.6-0.3,6.6c-0.1,0.9-0.8,1.6-1.7,1.7h-6.6C264.7,11.1,264,10.5,263.9,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-75",
    className: "st41",
    d: "M263.9,9.7c0,0,0-6.6,0.3-6.6c0.1-0.9,0.8-1.6,1.7-1.7h6.6c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.6-0.3,6.6c-0.1,0.9-0.8,1.6-1.7,1.7h-6.6C264.7,11.1,264,10.5,263.9,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-76",
    className: "st41",
    d: "M263.9,9.4c0,0,0-6.6,0.3-6.6c0.1-0.9,0.8-1.6,1.7-1.7h6.6c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.6-0.3,6.6c-0.1,0.9-0.8,1.6-1.7,1.7h-6.6c-0.7,0.2-1.4-0.1-1.6-0.8C263.9,9.8,263.9,9.6,263.9,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-77",
    className: "st42",
    d: "M263.9,9.4c0,0,0-6.6,0.3-6.6c0.1-0.9,0.8-1.6,1.7-1.7h6.6c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.6-0.3,6.6c-0.1,0.9-0.8,1.6-1.7,1.7h-6.6c-0.7,0.2-1.5-0.3-1.6-1.1C263.9,9.6,263.9,9.5,263.9,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-78",
    className: "st43",
    d: "M263.9,9.4c0,0,0-6.6,0.3-6.6c0.1-0.9,0.8-1.6,1.7-1.7h6.6c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.6-0.3,6.6c-0.1,0.9-0.8,1.6-1.7,1.7h-6.6c-0.7,0.2-1.5-0.3-1.6-1.1C263.9,9.6,263.9,9.5,263.9,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-79",
    className: "st43",
    d: "M263.9,9.4c0,0,0-6.3,0.3-6.3c0.1-0.9,0.8-1.6,1.7-1.7h6.6c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.3-0.3,6.3c-0.1,0.9-0.8,1.6-1.7,1.7h-6.6c-0.7,0.2-1.5-0.3-1.6-1.1C263.9,9.6,263.9,9.5,263.9,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-80",
    className: "st44",
    d: "M263.9,9.4c0,0,0-6.3,0.3-6.3c0.1-0.9,0.8-1.6,1.7-1.7h6.6c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.3-0.3,6.3c-0.1,0.9-0.8,1.6-1.7,1.7h-6.6c-0.7,0.2-1.5-0.3-1.6-1.1C263.9,9.6,263.9,9.5,263.9,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-81",
    className: "st44",
    d: "M263.9,9.4c0,0,0-6.3,0.3-6.3c0.1-0.9,0.8-1.6,1.7-1.7h6.6c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.3-0.3,6.3c-0.1,0.9-0.8,1.6-1.7,1.7h-6.6c-0.7,0.2-1.5-0.3-1.6-1.1C263.9,9.6,263.9,9.5,263.9,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-82",
    className: "st45",
    d: "M263.9,9.4c0,0,0-6.3,0.3-6.3c0.1-0.9,0.8-1.6,1.7-1.7h6.6c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.3-0.3,6.3c-0.1,0.9-0.8,1.6-1.7,1.7h-6.6c-0.7,0.2-1.5-0.3-1.6-1.1C263.9,9.6,263.9,9.5,263.9,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-83",
    className: "st46",
    d: "M263.9,9.4c0,0,0-6.3,0.3-6.3c0-0.8,0.8-1.4,1.7-1.7h6.6c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.3-0.3,6.3c0,0.8-0.8,1.4-1.7,1.7h-6.6C264.7,10.8,264,10.2,263.9,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-84",
    className: "st47",
    d: "M264.2,9.4c0,0,0-6.3,0.3-6.3c0.1-0.8,0.8-1.4,1.7-1.4h6.3c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.3-0.3,6.3c-0.1,0.8-0.8,1.4-1.7,1.4h-6.3C264.7,10.8,264.2,10.2,264.2,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-85",
    className: "st48",
    d: "M264.2,9.4c0,0,0-6.3,0.3-6.3c0.1-0.8,0.8-1.4,1.7-1.4h6.3c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.3-0.3,6.3c-0.1,0.8-0.8,1.4-1.7,1.4h-6.3C264.7,10.8,264.2,10.2,264.2,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-86",
    className: "st48",
    d: "M264.2,9.4c0,0,0-6.3,0.3-6.3c0.1-0.8,0.8-1.4,1.7-1.4h6.3c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.3-0.3,6.3c-0.1,0.8-0.8,1.4-1.7,1.4h-6.3C264.7,10.8,264.2,10.2,264.2,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-87",
    className: "st49",
    d: "M264.2,9.4c0,0,0-6.3,0.3-6.3c0.1-0.8,0.8-1.4,1.7-1.4h6.3c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.3-0.3,6.3c-0.1,0.8-0.8,1.4-1.7,1.4h-6.3C264.7,10.8,264.2,10.2,264.2,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-88",
    className: "st50",
    d: "M264.2,9.4c0,0,0-6.1,0.3-6.1c0.1-0.8,0.8-1.4,1.7-1.4h6.3c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.1-0.3,6.1c-0.1,0.8-0.8,1.4-1.7,1.4h-6.3C264.7,10.8,264.2,10.2,264.2,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-89",
    className: "st51",
    d: "M264.2,9.4c0,0,0-6.1,0.3-6.1c0.1-0.8,0.8-1.4,1.7-1.4h6.3c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.1-0.3,6.1c-0.1,0.8-0.8,1.4-1.7,1.4h-6.3C264.7,10.8,264.2,10.2,264.2,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-90",
    className: "st52",
    d: "M264.2,9.4c0,0,0-6.1,0.3-6.1c0.1-0.8,0.8-1.4,1.7-1.4h6.3c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.1-0.3,6.1c-0.1,0.8-0.8,1.4-1.7,1.4h-6.3C264.7,10.8,264.2,10.2,264.2,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-91",
    className: "st52",
    d: "M264.2,9.4c0,0,0-6.1,0.3-6.1c0.1-0.8,0.8-1.4,1.7-1.4h6.3c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.1-0.3,6.1c-0.1,0.8-0.8,1.4-1.7,1.4h-6.3C264.7,10.8,264.2,10.2,264.2,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-92",
    className: "st53",
    d: "M264.2,9.4c0,0,0-6.1,0.3-6.1c0.1-0.8,0.8-1.4,1.7-1.4h6.3c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.1-0.3,6.1c-0.1,0.8-0.8,1.4-1.7,1.4h-6.3C265,10.7,264.3,10.2,264.2,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-93",
    className: "st54",
    d: "M264.2,9.4c0,0,0-6.1,0.3-6.1c0.1-0.8,0.8-1.4,1.7-1.4h6.3c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.1-0.3,6.1c-0.1,0.8-0.8,1.4-1.7,1.4h-6.3C265,10.7,264.3,10.2,264.2,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-94",
    className: "st55",
    d: "M264.2,9.4c0,0,0-6.1,0.3-6.1c0.1-0.8,0.8-1.4,1.7-1.4h6.3c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.1-0.3,6.1c-0.1,0.8-0.8,1.4-1.7,1.4h-6.3C265,10.7,264.3,10.2,264.2,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-95",
    className: "st56",
    d: "M264.2,9.4c0,0,0-6.1,0.3-6.1c0.1-0.8,0.8-1.4,1.7-1.4h6.1c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.1-0.3,6.1c-0.1,0.8-0.8,1.4-1.7,1.4h-6.1C265,10.7,264.3,10.2,264.2,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-96",
    className: "st56",
    d: "M264.2,9.1c0,0,0-6.1,0.3-6.1c0.1-0.8,0.8-1.4,1.7-1.4h6.1c0.8-0.1,1.6,0.5,1.7,1.4 c0,0,0,6.1-0.3,6.1c-0.1,0.8-0.8,1.4-1.7,1.4h-6.1C265,10.6,264.3,9.9,264.2,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-97",
    className: "st57",
    d: "M264.2,9.1c0,0,0-5.8,0.3-5.8c0.1-0.8,0.8-1.4,1.7-1.4c0,0,6.1,0,6.1-0.3c0.7,0,1.3,0.5,1.4,1.2 c0,0.1,0,0.1,0,0.2c0,0,0,5.8-0.3,5.8c-0.1,0.8-0.8,1.4-1.7,1.4c0,0-6.1,0-6.1,0.3C264.8,10.4,264.2,9.9,264.2,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-98",
    className: "st58",
    d: "M264.2,9.1c0,0,0-5.8,0.3-5.8c0.1-0.8,0.8-1.4,1.7-1.4c0,0,6.1,0,6.1-0.3c0.7,0,1.3,0.5,1.4,1.2 c0,0.1,0,0.1,0,0.2c0,0,0,5.8-0.3,5.8c-0.1,0.8-0.8,1.4-1.7,1.4c0,0-6.1,0-6.1,0.3C264.8,10.4,264.2,9.9,264.2,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-99",
    className: "st58",
    d: "M264.2,9.1c0,0,0-5.8,0.3-5.8c0.1-0.8,0.8-1.4,1.7-1.4c0,0,6.1,0,6.1-0.3c0.7,0,1.3,0.5,1.4,1.2 c0,0.1,0,0.1,0,0.2c0,0,0,5.8-0.3,5.8c-0.1,0.8-0.8,1.4-1.7,1.4c0,0-6.1,0-6.1,0.3C264.8,10.4,264.2,9.9,264.2,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-100",
    className: "st59",
    d: "M264.4,9.1c0,0,0-5.8,0.3-5.8c0.1-0.8,0.8-1.4,1.7-1.4c0,0,6.1,0,6.1-0.3 c0.7,0,1.3,0.5,1.4,1.2c0,0.1,0,0.1,0,0.2c0,0,0,5.8-0.3,5.8c-0.1,0.8-0.8,1.4-1.7,1.4c0,0-6.1,0-6.1,0.3c-0.7,0-1.3-0.5-1.4-1.2 C264.4,9.2,264.4,9.2,264.4,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-101",
    className: "st59",
    d: "M264.4,9.1c0,0,0-5.8,0.3-5.8c0.1-0.8,0.8-1.4,1.7-1.4c0,0,6.1,0,6.1-0.3 c0.7,0,1.3,0.5,1.4,1.2c0,0.1,0,0.1,0,0.2c0,0,0,5.8-0.3,5.8c-0.1,0.8-0.8,1.4-1.7,1.4c0,0-6.1,0-6.1,0.3c-0.7,0-1.3-0.5-1.4-1.2 C264.4,9.2,264.4,9.2,264.4,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-102",
    className: "st60",
    d: "M264.4,9.1c0,0,0-5.8,0.3-5.8c0.1-0.8,0.8-1.4,1.7-1.4c0,0,6.1,0,6.1-0.3 c0.7,0,1.3,0.5,1.4,1.2c0,0.1,0,0.1,0,0.2c0,0,0,5.8-0.3,5.8c-0.1,0.8-0.8,1.4-1.7,1.4c0,0-6.1,0-6.1,0.3c-0.7,0-1.3-0.5-1.4-1.2 C264.4,9.2,264.4,9.2,264.4,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-103",
    className: "st61",
    d: "M264.4,9.1c0,0,0-5.8,0.3-5.8c0.1-0.8,0.8-1.4,1.7-1.4c0,0,6.1,0,6.1-0.3 c0.7,0,1.3,0.5,1.4,1.2c0,0.1,0,0.1,0,0.2c0,0,0,5.8-0.3,5.8c-0.1,0.8-0.8,1.4-1.7,1.4c0,0-6.1,0-6.1,0.3c-0.7,0-1.3-0.5-1.4-1.2 C264.4,9.2,264.4,9.2,264.4,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-104",
    className: "st62",
    d: "M264.4,9.1c0,0.3,0-5.8,0.3-5.8c0.1-0.8,0.8-1.4,1.7-1.4c0,0,6.1,0,6.1-0.3 c0.7,0,1.3,0.5,1.4,1.2c0,0.1,0,0.1,0,0.2c0-0.3,0,5.8-0.3,5.8c-0.1,0.8-0.8,1.4-1.7,1.4c0,0-6.1,0-6.1,0.3c-0.7,0-1.3-0.5-1.4-1.2 C264.4,9.2,264.4,9.2,264.4,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-105",
    className: "st63",
    d: "M264.4,9.1c0,0.3,0-5.8,0.3-5.8c0.1-0.8,0.8-1.4,1.7-1.4c0,0,5.8,0,6.1-0.3 c0.7,0,1.3,0.5,1.4,1.2c0,0.1,0,0.1,0,0.2c0-0.3,0,5.8-0.3,5.8c-0.1,0.8-0.8,1.4-1.7,1.4c0,0-5.8,0-6.1,0.3c-0.7,0-1.3-0.5-1.4-1.2 C264.4,9.2,264.4,9.2,264.4,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-106",
    className: "st63",
    d: "M264.4,9.1c0,0.3,0-5.5,0.3-5.5c0.1-0.8,0.8-1.4,1.7-1.4c0,0,5.8,0,5.8-0.3 c0.7,0,1.3,0.5,1.4,1.2c0,0.1,0,0.1,0,0.2c0-0.3,0,5.5-0.3,5.5c-0.1,0.8-0.8,1.4-1.7,1.4c0,0-5.8,0-5.8,0.3c-0.7,0-1.3-0.5-1.4-1.2 C264.4,9.2,264.4,9.2,264.4,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-107",
    className: "st64",
    d: "M264.4,9.1c0,0.3,0-5.5,0.3-5.5c0.1-0.8,0.8-1.4,1.7-1.4c0,0,5.8,0,5.8-0.3 c0.7,0,1.3,0.5,1.4,1.2c0,0.1,0,0.1,0,0.2c0-0.3,0,5.5-0.3,5.5c-0.1,0.8-0.8,1.4-1.7,1.4c0,0-5.8,0-5.8,0.3c-0.7,0-1.3-0.5-1.4-1.2 C264.4,9.2,264.4,9.2,264.4,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-108",
    className: "st65",
    d: "M264.4,9.1c0,0.3,0-5.5,0.3-5.5c0-0.7,0.6-1.3,1.4-1.4c0,0,5.8,0,5.8-0.3 c0.7,0,1.3,0.5,1.4,1.2c0,0.1,0,0.1,0,0.2c0-0.3,0,5.5-0.3,5.5c-0.1,0.8-0.8,1.4-1.7,1.4c0,0-5.8,0-5.8,0.3 C265,10.5,264.4,9.7,264.4,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-109",
    className: "st66",
    d: "M264.4,9.1c0,0.3,0-5.5,0.3-5.5c0-0.7,0.6-1.3,1.4-1.4c0,0,5.8,0,5.8-0.3 c0.7,0,1.3,0.5,1.4,1.2c0,0.1,0,0.1,0,0.2c0-0.3,0,5.5-0.3,5.5c0,0.7-0.6,1.3-1.4,1.4c0,0-5.8,0-5.8,0.3 C265,10.2,264.4,9.7,264.4,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-110",
    className: "st67",
    d: "M264.4,9.1c0,0.3,0-5.5,0.3-5.5c0-0.7,0.6-1.3,1.4-1.4c0,0,5.8,0,5.8-0.3 c0.7,0,1.3,0.5,1.4,1.2c0,0.1,0,0.1,0,0.2c0-0.3,0,5.5-0.3,5.5c0,0.7-0.6,1.3-1.4,1.4c0,0-5.8,0-5.8,0.3 C265,10.2,264.4,9.7,264.4,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-111",
    className: "st67",
    d: "M264.4,9.1c0,0.3,0-5.5,0.3-5.5c0-0.7,0.6-1.3,1.4-1.4c0,0,5.8,0,5.8-0.3 c0.7,0,1.3,0.5,1.4,1.2c0,0.1,0,0.1,0,0.2c0-0.3,0,5.5-0.3,5.5c0,0.7-0.6,1.3-1.4,1.4c0,0-5.8,0-5.8,0.3 C265,10.2,264.4,9.7,264.4,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-112",
    className: "st68",
    d: "M264.4,9.1c0,0.3,0-5.5,0.3-5.5c0-0.7,0.6-1.3,1.4-1.4c0,0,5.8,0,5.8-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3,0,5.5-0.3,5.5c0,0.7-0.6,1.3-1.4,1.4c0,0-5.8,0-5.8,0.3C265.3,10.2,264.4,9.7,264.4,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-113",
    className: "st68",
    d: "M264.4,9.1c0,0.3,0-5.5,0.3-5.5c0-0.7,0.5-1.3,1.2-1.4c0.1,0,0.1,0,0.2,0c0,0,5.8,0,5.8-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3,0,5.5-0.3,5.5c0,0.7-0.6,1.3-1.4,1.4c0,0-5.8,0-5.8,0.3C265.3,10.2,264.4,9.7,264.4,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-114",
    className: "st69",
    d: "M264.4,9.1c0,0.3,0-5.5,0.3-5.5c0-0.7,0.5-1.3,1.2-1.4c0.1,0,0.1,0,0.2,0c0,0,5.8,0,5.8-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3,0,5.5-0.3,5.5c0,0.7-0.5,1.3-1.2,1.4c-0.1,0-0.1,0-0.2,0c0,0-5.8,0-5.8,0.3 C265.3,10.2,264.4,9.7,264.4,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-115",
    className: "st70",
    d: "M264.4,9.1c0,0.3,0-5.2,0.3-5.2c0-0.7,0.5-1.3,1.2-1.4c0.1,0,0.1,0,0.2,0c0,0,5.8,0,5.8-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3,0,5.2-0.3,5.2c0,0.7-0.5,1.3-1.2,1.4c-0.1,0-0.1,0-0.2,0c0,0-5.8,0-5.8,0.3 C265.3,10.2,264.4,9.7,264.4,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-116",
    className: "st70",
    d: "M264.7,8.8c0,0.3,0-5.2,0.3-5.2c0-0.7,0.5-1.3,1.2-1.4c0.1,0,0.1,0,0.2,0c0,0,5.5,0,5.8-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3,0,5.2-0.3,5.2c0,0.7-0.5,1.3-1.2,1.4c-0.1,0-0.1,0-0.2,0c0,0-5.5,0-5.8,0.3 C265.3,10.2,264.7,9.7,264.7,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-117",
    className: "st71",
    d: "M264.7,8.8c0,0.3,0-5.2,0.3-5.2c0-0.7,0.5-1.3,1.2-1.4c0.1,0,0.1,0,0.2,0c0,0,5.5,0,5.5-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3,0,5.2-0.3,5.2c0,0.7-0.5,1.3-1.2,1.4c-0.1,0-0.1,0-0.2,0c0,0-5.5,0-5.5,0.3 C265.3,10.2,264.7,9.7,264.7,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-118",
    className: "st71",
    d: "M264.7,8.8c0,0.3,0-5.2,0.3-5.2c0-0.7,0.5-1.3,1.2-1.4c0.1,0,0.1,0,0.2,0c0,0,5.5,0,5.5-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3,0,5.2-0.3,5.2c0,0.7-0.5,1.3-1.2,1.4c-0.1,0-0.1,0-0.2,0c0,0-5.5,0-5.5,0.3 C265.3,10.2,264.7,9.7,264.7,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-119",
    className: "st72",
    d: "M264.7,8.8c0,0.3,0-5.2,0.3-5.2c0-0.7,0.5-1.3,1.2-1.4c0.1,0,0.1,0,0.2,0c0,0,5.5,0,5.5-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3,0,5.2-0.3,5.2c0,0.7-0.5,1.3-1.2,1.4c-0.1,0-0.1,0-0.2,0c0,0-5.5,0-5.5,0.3 C265.3,10.2,264.7,9.7,264.7,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-120",
    className: "st0",
    d: "M264.7,8.8c0,0.3,0-5.2,0.3-5.2c0-0.7,0.5-1.3,1.2-1.4c0.1,0,0.1,0,0.2,0c0,0,5.5,0,5.5-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3,0,5.2-0.3,5.2c0,0.7-0.5,1.3-1.2,1.4c-0.1,0-0.1,0-0.2,0c0,0-5.5,0-5.5,0.3 C265.3,10.2,264.7,9.7,264.7,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-121",
    className: "st73",
    d: "M264.7,8.8c0,0.3,0-5.2,0.3-5.2c0-0.7,0.5-1.3,1.2-1.4c0.1,0,0.1,0,0.2,0c0,0,5.5,0,5.5-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3,0,5.2-0.3,5.2c0,0.7-0.5,1.3-1.2,1.4c-0.1,0-0.1,0-0.2,0c0,0-5.5,0-5.5,0.3 C265.3,10.2,264.7,9.7,264.7,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-122",
    className: "st74",
    d: "M264.7,8.8c0,0.3,0-5.2,0.3-5.2c0-0.7,0.5-1.3,1.2-1.4c0.1,0,0.1,0,0.2,0c0,0,5.5,0,5.5-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3,0,5.2-0.3,5.2c0,0.7-0.5,1.3-1.2,1.4c-0.1,0-0.1,0-0.2,0c0,0-5.5,0-5.5,0.3 C265.3,10.2,264.7,9.7,264.7,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-123",
    className: "st74",
    d: "M264.7,8.8c0,0.3,0-5.2,0.3-5.2c0-0.7,0.5-1.3,1.2-1.4c0.1,0,0.1,0,0.2,0c0,0,5.5,0,5.5-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3,0,5.2-0.3,5.2c0,0.7-0.5,1.3-1.2,1.4c-0.1,0-0.1,0-0.2,0c0,0-5.5,0-5.5,0.3 C265.3,9.9,264.7,9.7,264.7,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-124",
    className: "st75",
    d: "M264.7,8.8c0,0.3,0.3-5,0.3-5c0-0.7,0.5-1.3,1.2-1.4c0.1,0,0.1,0,0.2,0c0,0,5.5,0,5.5-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3,0,5-0.3,5c0,0.7-0.6,1.3-1.4,1.4c0,0-5.5,0-5.5,0.3C265.4,10,264.8,9.5,264.7,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-125",
    className: "st75",
    d: "M264.7,8.8c0,0.3,0.3-5,0.3-5c0-0.7,0.6-1.3,1.4-1.4c0,0,5.5,0,5.5-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3-0.3,5-0.3,5c0,0.7-0.6,1.3-1.4,1.4c0,0-5.5,0-5.5,0.3C265.4,10,264.8,9.5,264.7,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-126",
    className: "st76",
    d: "M264.7,8.8c0,0.3,0.3-5,0.3-5c0-0.7,0.6-1.3,1.4-1.4c0,0,5.5,0,5.5-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3-0.3,5-0.3,5c0,0.7-0.6,1.3-1.4,1.4c0,0-5.5,0-5.5,0.3C265.4,10,264.8,9.5,264.7,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-127",
    className: "st77",
    d: "M264.7,8.8c0,0.3,0.3-5,0.3-5c0-0.6,0.6-1.1,1.4-1.4c0,0,5.2,0,5.5-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3-0.3,5-0.3,5c0,0.6-0.6,1.1-1.4,1.4c0,0-5.2,0-5.5,0.3C265.4,10,264.8,9.5,264.7,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-128",
    className: "st77",
    d: "M264.7,8.8c0,0.3,0.3-5,0.3-5c0-0.6,0.6-1.1,1.4-1.4c0,0,5.2,0,5.2-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3-0.3,5-0.3,5c0,0.6-0.6,1.1-1.4,1.4c0,0-5.2,0-5.2,0.3C265.4,10,264.8,9.5,264.7,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-129",
    className: "st78",
    d: "M264.7,8.8c0,0.3,0.3-5,0.3-5c0.1-0.7,0.7-1.2,1.4-1.1c0,0,5.2,0,5.2-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3-0.3,5-0.3,5c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-5.2,0-5.2,0.3C265.4,10,264.8,9.5,264.7,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-130",
    className: "st78",
    d: "M264.7,8.8c0,0.3,0.3-5,0.3-5c0.1-0.7,0.7-1.2,1.4-1.1c0,0,5.2,0,5.2-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3-0.3,5-0.3,5c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-5.2,0-5.2,0.3C265.4,10,264.8,9.5,264.7,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-131",
    className: "st79",
    d: "M264.7,8.8c0,0.3,0.3-5,0.3-5c0.1-0.7,0.7-1.2,1.4-1.1c0,0,5.2,0,5.2-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3-0.3,5-0.3,5c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-5.2,0-5.2,0.3C265.5,9.9,264.7,9.4,264.7,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-132",
    className: "st80",
    d: "M265,8.8c0,0.3,0.3-5,0.3-5c0.1-0.7,0.7-1.2,1.4-1.1c0,0,5.2,0,5.2-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3-0.3,5-0.3,5c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-5.2,0-5.2,0.3C265.7,10,265.1,9.5,265,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-133",
    className: "st81",
    d: "M265,8.8c0,0.3,0.3-4.7,0.3-4.7c0.1-0.7,0.7-1.2,1.4-1.1c0,0,5.2,0,5.2-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3-0.3,4.7-0.3,4.7c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-5.2,0-5.2,0.3C265.7,10,265.1,9.5,265,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-134",
    className: "st82",
    d: "M265,8.8c0,0.3,0.3-4.7,0.3-4.7c0.1-0.7,0.7-1.2,1.4-1.1c0,0,5.2,0,5.2-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3-0.3,4.7-0.3,4.7c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-5.2,0-5.2,0.3C265.7,10,265.1,9.5,265,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-135",
    className: "st82",
    d: "M265,8.8c0,0.3,0.3-4.7,0.3-4.7c0.1-0.7,0.7-1.2,1.4-1.1c0,0,5.2,0,5.2-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3-0.3,4.7-0.3,4.7c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-5.2,0-5.2,0.3C265.7,10,265.1,9.5,265,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-136",
    className: "st83",
    d: "M265,8.6c0,0.3,0.3-4.7,0.3-4.7c0.1-0.7,0.7-1.2,1.4-1.1c0,0,5.2,0,5.2-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3-0.3,4.7-0.3,4.7c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-5.2,0-5.2,0.3C265.5,9.7,265,9.4,265,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-137",
    className: "st83",
    d: "M265,8.6c0,0.3,0.3-4.7,0.3-4.7c0.1-0.7,0.7-1.2,1.4-1.1c0,0,5.2,0,5.2-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3-0.3,4.7-0.3,4.7c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-5.2,0-5.2,0.3C265.5,9.7,265,9.4,265,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-138",
    className: "st84",
    d: "M265,8.6c0,0.3,0.3-4.7,0.3-4.7c0.1-0.7,0.7-1.2,1.4-1.1c0,0,5,0,5.2-0.3 c0.7-0.1,1.3,0.4,1.4,1.1c0-0.3-0.3,4.7-0.3,4.7c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-5,0-5.2,0.3C265.5,9.7,265,9.4,265,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-139",
    className: "st85",
    d: "M265,8.6c0,0.3,0.3-4.7,0.3-4.7c0-0.6,0.8-1.1,1.4-1.1c0,0,5,0,5-0.3c0.6,0,1.1,0.5,1.1,1.1 c0-0.3-0.3,4.7-0.3,4.7c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-5,0-5,0.3C265.5,9.6,265,9.1,265,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-140",
    className: "st86",
    d: "M265,8.6c0,0.3,0.3-4.7,0.3-4.7c0-0.6,0.8-1.1,1.4-1.1h5c0.6,0,1.1,0.5,1.1,1.1 c0-0.3-0.3,4.7-0.3,4.7c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-5,0-5,0.3C265.5,9.7,265.1,9.2,265,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-141",
    className: "st87",
    d: "M265,8.6c0,0.3,0.3-4.7,0.3-4.7c0.2-0.6,0.8-1,1.4-1.1h5c0.6,0,1.1,0.5,1.1,1.1 c0-0.3-0.3,4.7-0.3,4.7c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-5,0-5,0.3C265.5,9.7,265.1,9.2,265,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-142",
    className: "st88",
    d: "M265,8.6c0,0.3,0.3-4.7,0.3-4.7c0.1-0.7,0.7-1.2,1.4-1.1h5c0.6,0,1.1,0.5,1.1,1.1 c0-0.3-0.3,4.4-0.3,4.4c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-5,0-5,0.3C265.5,9.6,265,9.1,265,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-143",
    className: "st89",
    d: "M265,8.6c0,0.3,0.3-4.4,0.3-4.4c0.1-0.7,0.7-1.2,1.4-1.1c0.3-0.3,5-0.3,5-0.3 c0.6,0,1.1,0.5,1.1,1.1c0-0.3-0.3,4.4-0.3,4.4c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-5,0-5,0.3C265.5,9.6,265,9.1,265,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-144",
    className: "st89",
    d: "M265,8.6c0,0.3,0.3-4.4,0.3-4.4c0.1-0.7,0.7-1.2,1.4-1.1c0,0,5,0,5-0.3c0.6,0,1.1,0.5,1.1,1.1 c0-0.3-0.3,4.4-0.3,4.4c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-5,0-5,0.3C265.5,9.6,265,9.1,265,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-145",
    className: "st90",
    d: "M265,8.6c0,0.3,0.3-4.4,0.3-4.4c0.1-0.7,0.7-1.2,1.4-1.1c0,0,5,0,5-0.3c0.6,0,1.1,0.5,1.1,1.1 c0-0.3-0.3,4.4-0.3,4.4c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-5,0-5,0.3C265.5,9.6,265,9.1,265,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-146",
    className: "st90",
    d: "M265,8.6c0,0.3,0.3-4.4,0.3-4.4c0.1-0.7,0.7-1.2,1.4-1.1c0,0,5,0,5-0.3c0.6,0,1.1,0.5,1.1,1.1 c0-0.3-0.3,4.4-0.3,4.4c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-5,0-5,0.3C265.5,9.6,265,9.1,265,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-147",
    className: "st91",
    d: "M265,8.6c0,0.3,0.3-4.4,0.3-4.4c0.1-0.7,0.7-1.2,1.4-1.1c0,0,5,0,5-0.3c0.6-0.1,1,0.4,1.1,0.9 c0,0.1,0,0.1,0,0.2c0-0.3-0.3,4.4-0.3,4.4c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-5,0-5,0.3C265.5,9.6,265,9.1,265,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-148",
    className: "st92",
    d: "M265,8.6c0,0.3,0.3-4.4,0.3-4.4c0.1-0.7,0.7-1.2,1.4-1.1c0,0,4.7,0,5-0.3 c0.6-0.1,1,0.4,1.1,0.9c0,0.1,0,0.1,0,0.2c0-0.3-0.3,4.4-0.3,4.4c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-4.7,0-5,0.3 C265.5,9.6,265,9.1,265,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-149",
    className: "st93",
    d: "M265.3,8.6c0,0.3,0.3-4.4,0.3-4.4c0.1-0.7,0.7-1.2,1.4-1.1c0,0,4.7,0,5-0.3 c0.6,0,1.1,0.3,1.1,0.8c0-0.3-0.3,4.4-0.3,4.4c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-4.7,0-5,0.3C265.5,9.4,265.3,9.1,265.3,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-150",
    className: "st94",
    d: "M265.3,8.6c0,0.3,0.3-4.4,0.3-4.4c0.1-0.7,0.7-1.2,1.4-1.1c0,0,4.7,0,4.7-0.3 c0.6,0,1.1,0.3,1.1,0.8c0-0.3-0.3,4.4-0.3,4.4c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-4.7,0-4.7,0.3C265.8,9.4,265.3,9.1,265.3,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-151",
    className: "st94",
    d: "M265.3,8.6c0,0.3,0.3-4.4,0.3-4.4c0.1-0.7,0.7-1.2,1.4-1.1c0,0,4.7,0,4.7-0.3 c0.6,0,1.1,0.3,1.1,0.8c0-0.3-0.3,4.4-0.3,4.4c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-4.7,0-4.7,0.3C265.8,9.4,265.3,9.1,265.3,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-152",
    className: "st95",
    d: "M265.3,8.6c0,0.3,0.3-4.1,0.3-4.1c0.1-0.7,0.7-1.2,1.4-1.1c0,0,4.7,0,4.7-0.3 c0.6,0,1.1,0.3,1.1,0.8c0-0.3-0.3,4.1-0.3,4.1c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-4.7,0-4.7,0.3C265.8,9.4,265.3,9.1,265.3,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-153",
    className: "st95",
    d: "M265.3,8.6c0,0.3,0.3-4.1,0.3-4.1c0.1-0.7,0.7-1.2,1.4-1.1c0,0,4.7,0,4.7-0.3 c0.6,0,1.1,0.3,1.1,0.8c0-0.3-0.3,4.1-0.3,4.1c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-4.7,0-4.7,0.3C265.8,9.4,265.3,9.1,265.3,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-154",
    className: "st96",
    d: "M265.3,8.6c0,0.3,0.3-4.1,0.3-4.1c0.1-0.7,0.7-1.2,1.4-1.1c0,0,4.7,0,4.7-0.3 c0.6,0,1.1,0.3,1.1,0.8c0-0.3-0.3,4.1-0.3,4.1c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-4.7,0-4.7,0.3C265.8,9.4,265.3,9.1,265.3,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-155",
    className: "st97",
    d: "M265.3,8.6c0,0.3,0.3-4.1,0.3-4.1c0.1-0.7,0.7-1.2,1.4-1.1c0,0,4.7,0,4.7-0.3 c0.6,0,1.1,0.3,1.1,0.8c0-0.3-0.3,4.1-0.3,4.1c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-4.7,0-4.7,0.3C265.9,9.4,265.4,9,265.3,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-156",
    className: "st98",
    d: "M265.3,8.6c0,0.3,0.3-4.1,0.3-4.1c0-0.6,0.5-1.1,1.1-1.1c0,0,4.7,0,4.7-0.3 c0.6,0,1.1,0.3,1.1,0.8c0-0.3-0.3,4.1-0.3,4.1c-0.1,0.7-0.7,1.2-1.4,1.1c0,0-4.7,0-4.7,0.3C265.7,9.3,265.4,9,265.3,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-157",
    className: "st99",
    d: "M265.3,8.3c0,0.3,0.3-4.1,0.3-4.1c0-0.6,0.5-1.1,1.1-1.1c0,0,4.7,0,4.7-0.3 c0.6,0,1.1,0.3,1.1,0.8c0-0.3-0.3,4.1-0.3,4.1c0,0.6-0.5,1.1-1.1,1.1c0,0-4.7,0-4.7,0.3C265.8,9.4,265.3,8.8,265.3,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-158",
    className: "st100",
    d: "M265.3,8.3c0,0.3,0.3-4.1,0.3-4.1c0-0.6,0.5-1.1,1.1-1.1c0,0,4.7,0,4.7-0.3 c0.6,0,1.1,0.3,1.1,0.8c0-0.3-0.3,4.1-0.3,4.1c0,0.6-0.5,1.1-1.1,1.1c0,0-4.7,0-4.7,0.3C265.8,9.4,265.3,8.8,265.3,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-159",
    className: "st101",
    d: "M265.3,8.3c0,0.3,0.3-4.1,0.6-4.1c0-0.6,0.5-1.1,1.1-1.1c0,0,4.4,0,4.7-0.3 c0.6,0,1.1,0.3,1.1,0.8c0-0.3-0.3,4.1-0.6,4.1c0,0.6-0.5,1.1-1.1,1.1c0,0-4.4,0-4.7,0.3C265.8,9.4,265.3,8.8,265.3,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-160",
    className: "st101",
    d: "M265.3,8.3c0,0.3,0.3-4.1,0.6-4.1c0-0.6,0.5-1.1,1.1-1.1c0,0,4.4,0,4.7-0.3 c0.6,0,1.1,0.3,1.1,0.8c0-0.3-0.3,4.1-0.6,4.1c0,0.6-0.5,1.1-1.1,1.1c0,0-4.4,0-4.7,0.3C265.8,9.4,265.3,8.8,265.3,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-161",
    className: "st102",
    d: "M265.3,8.3c0,0.3,0.3-3.9,0.6-3.9c0-0.6,0.5-1.1,1.1-1.1c0,0,4.4,0,4.4-0.3 c0.6,0,1.1,0.3,1.1,0.8c0-0.3-0.3,3.9-0.6,3.9c0,0.6-0.5,1.1-1.1,1.1c0,0-4.4,0-4.4,0.3C265.8,9.4,265.3,8.8,265.3,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-162",
    className: "st102",
    d: "M265.3,8.3c0,0.3,0.3-3.9,0.6-3.9c0-0.6,0.5-1.1,1.1-1.1c0,0,4.4,0,4.4-0.3 c0.6,0,1.1,0.3,1.1,0.8c0-0.3-0.3,3.9-0.6,3.9c0,0.6-0.5,1.1-1.1,1.1c0,0-4.4,0-4.4,0.3C265.8,9.4,265.3,8.8,265.3,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-163",
    className: "st103",
    d: "M265.3,8.3c0,0.3,0.3-3.9,0.6-3.9c0-0.6,0.5-1.1,1.1-1.1l4.4-0.3c0.6,0,1.1,0.3,1.1,0.8 c0-0.3-0.3,3.9-0.6,3.9c0,0.6-0.5,1.1-1.1,1.1l-4.4,0.3C265.8,9.1,265.3,8.8,265.3,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-164",
    className: "st104",
    d: "M265.3,8.3c0,0.3,0.3-3.9,0.6-3.9c0-0.6,0.5-1.1,1.1-1.1l4.4-0.3c0.6,0,1.1,0.3,1.1,0.8 c0-0.3-0.3,3.9-0.6,3.9c0,0.6-0.5,1.1-1.1,1.1l-4.4,0.3C265.8,9.1,265.3,8.8,265.3,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-165",
    className: "st105",
    d: "M265.5,8.3c0,0.3,0.3-3.9,0.6-3.9c0-0.6,0.5-1.1,1.1-1.1l4.4-0.3c0.6,0,1.1,0.3,1.1,0.8 c0-0.3-0.3,3.9-0.6,3.9c0,0.6-0.5,1.1-1.1,1.1l-4.4,0.3C265.8,9.1,265.5,8.8,265.5,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-166",
    className: "st106",
    d: "M265.5,8.3c0,0.3,0.3-3.9,0.6-3.9c0-0.6,0.5-1.1,1.1-1.1l4.4-0.3c0.6,0,1.1,0.3,1.1,0.8 c0-0.3-0.3,3.9-0.6,3.9c0,0.6-0.5,1.1-1.1,1.1l-4.4,0.3C265.8,9.1,265.5,8.8,265.5,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-167",
    className: "st106",
    d: "M265.5,8.3c0,0.3,0.3-3.9,0.6-3.9c0-0.6,0.5-1.1,1.1-1.1l4.4-0.3c0.6,0,1.1,0.3,1.1,0.8 c0-0.3-0.3,3.9-0.6,3.9c0,0.6-0.5,1.1-1.1,1.1l-4.4,0.3C265.8,9.1,265.5,8.8,265.5,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-168",
    className: "st107",
    d: "M265.5,8.3c0,0.3,0.3-3.9,0.6-3.9c0-0.6,0.5-1.1,1.1-1.1l4.4-0.3c0.6,0,1.1,0.3,1.1,0.8 c0-0.3-0.3,3.9-0.6,3.9c0,0.6-0.5,1.1-1.1,1.1l-4.4,0.3C265.8,9.1,265.5,8.8,265.5,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-169",
    className: "st107",
    d: "M265.5,8.3c0,0.3,0.3-3.9,0.6-3.9c0-0.6,0.5-1.1,1.1-1.1l4.4-0.3c0.6,0,1.1,0.3,1.1,0.8 c0-0.3-0.3,3.9-0.6,3.9c0,0.6-0.5,1.1-1.1,1.1l-4.4,0.3C265.8,9.1,265.5,8.8,265.5,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-170",
    className: "st108",
    d: "M265.5,8.3c0,0.3,0.3-3.6,0.6-3.6c0-0.6,0.5-1.1,1.1-1.1c0,0,4.1-0.3,4.4-0.3 c0.6,0,1.1,0.3,1.1,0.8c0-0.3-0.3,3.6-0.6,3.6c0,0.6-0.5,1.1-1.1,1.1c0,0-4.1,0.3-4.4,0.3C266.1,9.1,265.5,8.8,265.5,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-171",
    className: "st108",
    d: "M265.5,8.3c0,0.3,0.3-3.6,0.6-3.6c0-0.6,0.6-0.8,1.1-1.1c0,0,4.1-0.3,4.4-0.3 c0.6,0,1.1,0.3,1.1,0.8c0-0.3-0.3,3.6-0.6,3.6c0,0.6-0.6,0.8-1.1,1.1c0,0-4.1,0.3-4.4,0.3C266.1,9.1,265.7,8.8,265.5,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-172",
    className: "st109",
    d: "M265.5,8.3c0,0.3,0.3-3.6,0.6-3.6c0-0.6,0.6-0.8,1.1-1.1l4.1-0.3c0.6,0,1.1,0.3,1.1,0.8 c0-0.3-0.3,3.6-0.6,3.6c0,0.6-0.6,0.8-1.1,1.1l-4.1,0.3C266.1,9.1,265.7,8.8,265.5,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-173",
    className: "st110",
    d: "M265.5,8.3c0,0.3,0.3-3.6,0.6-3.6c0-0.6,0.6-0.8,1.1-1.1l4.1-0.3c0.6,0,1.1,0.3,1.1,0.8 c0-0.3-0.3,3.6-0.6,3.6c0,0.6-0.6,0.8-1.1,1.1l-4.1,0.3C266.1,9.1,265.7,8.8,265.5,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-174",
    className: "st111",
    d: "M265.5,8.3c0,0.3,0.3-3.6,0.6-3.6c0-0.6,0.6-0.8,1.1-0.8l4.1-0.3c0.6,0,1.1,0.3,1.1,0.8 c0-0.3-0.3,3.6-0.6,3.6c0,0.6-0.6,0.8-1.1,0.8l-4.1,0.3C266.2,9.1,265.7,8.8,265.5,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-175",
    className: "st112",
    d: "M265.5,8.3c0,0.3,0.3-3.6,0.6-3.6c0-0.6,0.6-0.8,1.1-0.8l4.1-0.3c0.6,0,1.1,0.3,1.1,0.8 c0-0.3-0.3,3.6-0.6,3.6c0,0.6-0.6,0.8-1.1,0.8l-4.1,0.3C266.2,9.1,265.7,8.8,265.5,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-176",
    className: "st112",
    d: "M265.5,8.3c0,0.3,0.3-3.6,0.6-3.6c0-0.6,0.6-0.8,1.1-0.8l4.1-0.3c0.6,0,1.1,0.3,1.1,0.8 c0-0.3-0.3,3.6-0.6,3.6c0,0.6-0.6,0.8-1.1,0.8l-4.1,0.3C266.1,8.8,265.6,8.6,265.5,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-177",
    className: "st113",
    d: "M265.5,8c0,0.3,0.3-3.6,0.6-3.6c0-0.6,0.6-0.8,1.1-0.8l4.1-0.3c0.6,0,1.1,0.3,1.1,0.8 c0-0.3-0.3,3.6-0.6,3.6c0,0.6-0.6,0.8-1.1,0.8l-4.1,0.3C266.1,8.8,265.6,8.6,265.5,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-178",
    className: "st113",
    d: "M265.5,8c0,0.3,0.3-3.6,0.6-3.6c0-0.6,0.6-0.8,1.1-0.8l4.1-0.3c0.6,0,1.1,0.3,1.1,0.8 c0-0.3-0.3,3.6-0.6,3.6c0,0.6-0.6,0.8-1.1,0.8l-4.1,0.3C266.1,8.8,265.6,8.6,265.5,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-179",
    className: "st114",
    d: "M265.5,8c0,0.3,0.3-3.3,0.6-3.3c0-0.6,0.6-0.8,1.1-0.8l4.1-0.3c0.6,0,1.1,0.3,1.1,0.8 c0-0.3-0.3,3.3-0.6,3.3c0,0.6-0.6,0.8-1.1,0.8l-4.1,0.3C266.1,8.8,265.6,8.6,265.5,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-180",
    className: "st114",
    d: "M265.5,8c0,0.3,0.3-3.3,0.6-3.3c0-0.6,0.6-0.8,1.1-0.8l4.1-0.3c0.6,0,1.1,0.3,1.1,0.8 c0-0.3-0.3,3.3-0.6,3.3c0,0.6-0.6,0.8-1.1,0.8l-4.1,0.3C266.1,8.8,265.6,8.6,265.5,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-181",
    className: "st115",
    d: "M265.8,8c0,0.3,0.3-3.3,0.6-3.3c0-0.6,0.6-0.8,1.1-0.8c0,0,3.9-0.3,4.1-0.3 c0.6,0,1.1,0.3,1.1,0.8c0-0.3-0.3,3.3-0.6,3.3c0,0.6-0.6,0.8-1.1,0.8c0,0-3.9,0.3-4.1,0.3C266.1,8.8,265.8,8.6,265.8,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-182",
    className: "st116",
    d: "M265.8,8c0,0.3,0.3-3.3,0.6-3.3c0-0.6,0.6-0.8,1.1-0.8c0,0,3.9-0.3,4.1-0.3 c0.4-0.1,0.8,0.2,0.8,0.6c0,0.1,0,0.1,0,0.2c0-0.3-0.3,3.3-0.6,3.3c0,0.6-0.6,0.8-1.1,0.8c0,0-3.9,0.3-4.1,0.3 c-0.4,0.1-0.8-0.2-0.8-0.6C265.8,8.1,265.8,8.1,265.8,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-183",
    className: "st117",
    d: "M265.8,8c0,0.3,0.3-3.3,0.6-3.3c0-0.6,0.6-0.8,1.1-0.8l3.9-0.3c0.4-0.1,0.8,0.2,0.8,0.6 c0,0.1,0,0.1,0,0.2c0-0.3-0.3,3.3-0.6,3.3c0,0.6-0.6,0.8-1.1,0.8l-3.9,0.3c-0.4,0.1-0.8-0.2-0.8-0.6C265.8,8.1,265.8,8.1,265.8,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-184",
    className: "st118",
    d: "M265.8,8c0,0.3,0.3-3.3,0.6-3.3c0-0.6,0.6-0.8,1.1-0.8c0.3,0,3.9-0.3,3.9-0.3 c0.4-0.1,0.8,0.2,0.8,0.6c0,0.1,0,0.1,0,0.2c0-0.3-0.3,3.3-0.6,3.3c0,0.6-0.6,0.8-1.1,0.8c-0.3,0-3.9,0.3-3.9,0.3 c-0.4,0.1-0.8-0.2-0.8-0.6C265.8,8.1,265.8,8.1,265.8,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-185",
    className: "st118",
    d: "M265.8,8c0,0.3,0.3-3.3,0.6-3.3c0-0.6,0.6-0.8,1.1-0.8c0.3,0,3.9-0.3,3.9-0.3 c0.4-0.1,0.8,0.2,0.8,0.6c0,0.1,0,0.1,0,0.2c0-0.3-0.3,3.3-0.6,3.3c0,0.6-0.6,0.8-1.1,0.8c-0.3,0-3.9,0.3-3.9,0.3 c-0.4,0.1-0.8-0.2-0.8-0.6C265.8,8.1,265.8,8.1,265.8,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-186",
    className: "st119",
    d: "M265.8,8c0,0.3,0.3-3.3,0.6-3.3c0-0.6,0.6-0.8,1.1-0.8c0.3,0,3.9-0.3,3.9-0.3 c0.4-0.1,0.8,0.2,0.8,0.6c0,0.1,0,0.1,0,0.2c0-0.3-0.3,3.3-0.6,3.3c0,0.3-0.6,0.6-1.1,0.6c-0.3,0-3.9,0.3-3.9,0.3 C266.1,8.8,265.8,8.6,265.8,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-187",
    className: "st119",
    d: "M265.8,8c0,0.3,0.3-3.3,0.6-3.3c0-0.6,0.6-0.8,1.1-0.8c0.3,0,3.9-0.3,3.9-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,3.3-0.6,3.3c0,0.6-0.6,0.8-1.1,0.8c-0.3,0-3.9,0.3-3.9,0.3C266.1,8.8,265.8,8.3,265.8,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-188",
    className: "st120",
    d: "M265.8,8c0,0.3,0.3-3,0.6-3c0-0.6,0.6-0.8,1.1-0.8c0.3,0,3.9-0.3,3.9-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,3-0.6,3c0,0.6-0.6,0.8-1.1,0.8c-0.3,0-3.9,0.3-3.9,0.3C266.1,8.8,265.8,8.3,265.8,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-189",
    className: "st120",
    d: "M265.8,8c0,0.3,0.3-3,0.6-3c0-0.6,0.6-0.8,1.1-0.8c0.3,0,3.9-0.3,3.9-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,3-0.6,3c0,0.6-0.6,0.8-1.1,0.8c-0.3,0-3.9,0.3-3.9,0.3C266.4,8.6,265.8,8.3,265.8,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-190",
    className: "st121",
    d: "M265.8,8c0,0.3,0.3-3,0.6-3c0-0.6,0.6-0.8,1.1-0.8c0.3,0,3.9-0.3,3.9-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,3-0.6,3c0,0.6-0.6,0.8-1.1,0.8c-0.3,0-3.9,0.3-3.9,0.3C266.4,8.6,265.8,8.3,265.8,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-191",
    className: "st122",
    d: "M265.8,8c0,0.3,0.3-3,0.6-3c0-0.6,0.6-0.8,1.1-0.8c0.3,0,3.9-0.3,3.9-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,3-0.6,3c0,0.6-0.6,0.8-1.1,0.8c-0.3,0-3.9,0.3-3.9,0.3C266.4,8.6,265.8,8.3,265.8,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-192",
    className: "st123",
    d: "M265.8,8c0,0.3,0.3-3,0.6-3c0-0.6,0.6-0.8,1.1-0.8c0.3,0,3.6-0.3,3.9-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,3-0.6,3c-0.2,0.5-0.6,0.8-1.1,0.8c-0.3,0-3.6,0.3-3.9,0.3S265.8,8.3,265.8,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-193",
    className: "st124",
    d: "M265.8,8c0,0.3,0.3-3,0.6-3c0-0.6,0.6-0.8,1.1-0.8c0.3,0,3.6-0.3,3.9-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,3-0.6,3c-0.2,0.5-0.6,0.8-1.1,0.8c-0.3,0-3.6,0.3-3.9,0.3S265.8,8.3,265.8,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-194",
    className: "st125",
    d: "M265.8,8c0,0.3,0.3-3,0.6-3c0-0.6,0.6-0.8,1.1-0.8c0.3,0,3.6-0.3,3.6-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,3-0.6,3c0.3,0.3-0.3,0.8-0.8,0.8c-0.3,0-3.6,0.3-3.6,0.3C266.4,8.6,265.8,8.3,265.8,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-195",
    className: "st126",
    d: "M265.8,8c0,0.3,0.3-3,0.6-3c0-0.6,0.6-0.8,1.1-0.8c0.3,0,3.6-0.3,3.6-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,3-0.6,3c0,0.6-0.6,0.8-1.1,0.8c-0.3,0-3.6,0.3-3.6,0.3C266.4,8.6,265.8,8.3,265.8,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-196",
    className: "st126",
    d: "M265.8,8c0,0.3,0.3-3,0.6-3c0-0.6,0.6-0.8,1.1-0.8c0.3,0,3.6-0.3,3.6-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,3-0.6,3c0,0.6-0.6,0.8-1.1,0.8c-0.3,0-3.6,0.3-3.6,0.3C266.4,8.6,265.8,8.3,265.8,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-197",
    className: "st127",
    d: "M266.1,7.7c0,0.3,0.3-2.8,0.6-2.8c0-0.6,0.6-0.8,1.1-0.8c0.3,0,3.6-0.3,3.6-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,2.8-0.6,2.8c0,0.6-0.6,0.8-1.1,0.8c-0.3,0-3.6,0.3-3.6,0.3C266.4,8.6,266.1,8.3,266.1,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-198",
    className: "st127",
    d: "M266.1,7.7c0,0.3,0.3-2.8,0.6-2.8c0-0.6,0.6-0.8,1.1-0.8c0.3,0,3.6-0.3,3.6-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,2.8-0.6,2.8c0,0.6-0.6,0.8-1.1,0.8c-0.3,0-3.6,0.3-3.6,0.3C266.4,8.6,266.1,8.3,266.1,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-199",
    className: "st128",
    d: "M266.1,7.7c0,0.3,0.3-2.8,0.6-2.8c0-0.6,0.6-0.8,1.1-0.8c0.3,0,3.6-0.3,3.6-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,2.8-0.6,2.8c0,0.6-0.6,0.8-1.1,0.8c-0.3,0-3.6,0.3-3.6,0.3C266.4,8.6,266.1,8.3,266.1,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-200",
    className: "st128",
    d: "M266.1,7.7c0,0.3,0.3-2.8,0.6-2.8c0-0.6,0.6-0.8,1.1-0.8c0.3,0,3.6-0.3,3.6-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,2.8-0.6,2.8c0,0.6-0.6,0.8-1.1,0.8c-0.3,0-3.6,0.3-3.6,0.3C266.4,8.6,266.1,8.3,266.1,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-201",
    className: "st129",
    d: "M266.1,7.7c0,0.3,0.3-2.8,0.6-2.8c0-0.6,0.6-0.8,1.1-0.8c0.3,0,3.6-0.3,3.6-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,2.8-0.6,2.8c0,0.6-0.6,0.8-1.1,0.8c-0.3,0-3.6,0.3-3.6,0.3C266.4,8.6,266.1,8.3,266.1,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-202",
    className: "st130",
    d: "M266.1,7.7c0,0.3,0.3-2.8,0.6-2.8c0-0.6,0.6-0.8,1.1-0.8c0.3,0,3.6-0.3,3.6-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,2.8-0.6,2.8c0,0.6-0.6,0.8-1.1,0.8c-0.3,0-3.6,0.3-3.6,0.3C266.4,8.3,266.1,8,266.1,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-203",
    className: "st131",
    d: "M266.1,7.7c0,0.3,0.3-2.8,0.6-2.8c0.2-0.5,0.6-0.8,1.1-0.8c0.3,0,3.3-0.3,3.6-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,2.8-0.6,2.8C271.4,7.7,271,8,270.5,8c-0.3,0-3.3,0.3-3.6,0.3C266.4,8.3,266.1,8,266.1,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-204",
    className: "st132",
    d: "M266.1,7.7c0,0.3,0.3-2.8,0.6-2.8c0.2-0.5,0.6-0.8,1.1-0.8c0.3,0,3.3-0.3,3.6-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,2.8-0.6,2.8C271.4,7.7,271,8,270.5,8c-0.3,0-3.3,0.3-3.6,0.3C266.4,8.3,266.1,8,266.1,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-205",
    className: "st133",
    d: "M266.1,7.7c0,0.3,0.3-2.8,0.6-2.8c0.1-0.4,0.4-0.7,0.8-0.8c0.3,0,3.3-0.3,3.3-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,2.8-0.6,2.8c-0.1,0.4-0.4,0.7-0.8,0.8c-0.3,0-3.3,0.3-3.3,0.3C266.4,8.3,266.1,8,266.1,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-206",
    className: "st134",
    d: "M266.1,7.7c0,0.3,0.3-2.5,0.6-2.5c0.1-0.4,0.4-0.7,0.8-0.8c0.3,0,3.3-0.3,3.3-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,2.5-0.6,2.5c-0.1,0.4-0.4,0.7-0.8,0.8c-0.3,0-3.3,0.3-3.3,0.3C266.4,8.3,266.1,8,266.1,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-207",
    className: "st135",
    d: "M266.1,7.7c0,0.3,0.3-2.5,0.6-2.5c0.1-0.4,0.4-0.7,0.8-0.8c0.3,0,3.3-0.3,3.3-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,2.5-0.6,2.5c-0.1,0.4-0.4,0.7-0.8,0.8c-0.3,0-3.3,0.3-3.3,0.3C266.4,8.3,266.1,8,266.1,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-208",
    className: "st136",
    d: "M266.1,7.7c0,0.3,0.3-2.5,0.6-2.5c0.1-0.4,0.4-0.7,0.8-0.8c0.3,0,3.3-0.3,3.3-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,2.5-0.6,2.5c-0.1,0.4-0.4,0.7-0.8,0.8c-0.3,0-3.3,0.3-3.3,0.3C266.4,8.3,266.1,8,266.1,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-209",
    className: "st136",
    d: "M266.1,7.7c0,0.3,0.3-2.5,0.6-2.5c0.1-0.4,0.4-0.7,0.8-0.8c0.3,0,3.3-0.3,3.3-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,2.5-0.6,2.5c-0.1,0.4-0.4,0.7-0.8,0.8c-0.3,0-3.3,0.3-3.3,0.3C266.6,8.3,266.1,8,266.1,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-210",
    className: "st137",
    d: "M266.1,7.7c0,0.3,0.3-2.5,0.6-2.5c0.1-0.4,0.4-0.7,0.8-0.8c0.3,0,3.3-0.3,3.3-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,2.5-0.6,2.5c-0.1,0.4-0.4,0.7-0.8,0.8c-0.3,0-3.3,0.3-3.3,0.3C266.6,8.3,266.1,8,266.1,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-211",
    className: "st137",
    d: "M266.1,7.7c0,0.3,0.3-2.5,0.6-2.5c0.1-0.4,0.4-0.7,0.8-0.8c0.3,0,3.3-0.3,3.3-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,2.5-0.6,2.5c-0.1,0.4-0.4,0.7-0.8,0.8c-0.3,0-3.3,0.3-3.3,0.3C266.6,8.3,266.1,8,266.1,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-212",
    className: "st138",
    d: "M266.1,7.7c0,0.3,0.3-2.5,0.6-2.5c0.1-0.4,0.4-0.7,0.8-0.8c0.3,0,3.3-0.3,3.3-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,2.5-0.6,2.5c-0.1,0.4-0.4,0.7-0.8,0.8c-0.3,0-3.3,0.3-3.3,0.3C266.6,8.3,266.1,8,266.1,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-213",
    className: "st138",
    d: "M266.4,7.7c0,0.3,0.3-2.5,0.6-2.5c0.1-0.4,0.4-0.7,0.8-0.8c0.3,0,3.3-0.3,3.3-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,2.5-0.6,2.5c-0.1,0.4-0.4,0.7-0.8,0.8c-0.3,0-3.3,0.3-3.3,0.3C266.6,8.3,266.4,8,266.4,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-214",
    className: "st139",
    d: "M266.4,7.7c0,0.3,0.3-2.5,0.6-2.5c0.1-0.4,0.4-0.7,0.8-0.8c0.3,0,3-0.3,3.3-0.3 c0.6,0,0.8,0.3,0.8,0.6c0-0.3-0.3,2.5-0.6,2.5c-0.1,0.4-0.4,0.7-0.8,0.8c-0.3,0-3,0.3-3.3,0.3C266.6,8.3,266.4,8,266.4,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-215",
    className: "st139",
    d: "M266.4,7.7c0,0.3,0.3-2.2,0.6-2.2c0-0.3,0.6-0.6,0.8-0.8c0.3,0,3-0.3,3.3-0.3s0.8,0.3,0.8,0.6 c0-0.3-0.3,2.2-0.6,2.2c0,0.3-0.6,0.6-0.8,0.8c-0.3,0-3,0.3-3.3,0.3C266.6,8.3,266.4,8,266.4,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-216",
    className: "st140",
    d: "M266.4,7.7c0,0.3,0.3-2.2,0.6-2.2c0-0.3,0.6-0.6,0.8-0.8c0.3,0,3-0.3,3-0.3 c0.3,0,0.8,0.3,0.8,0.6c0-0.3-0.3,2.2-0.6,2.2c0,0.3-0.6,0.6-0.8,0.8c-0.3,0-3,0.3-3,0.3C266.6,8,266.4,8,266.4,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-217",
    className: "st141",
    d: "M266.4,7.5c0,0.3,0.3-2.2,0.6-2.2c0-0.3,0.6-0.6,0.8-0.8c0.3,0,3-0.3,3-0.3 c0.3,0,0.8,0.3,0.8,0.6c0-0.3-0.3,2.2-0.6,2.2c0,0.3-0.6,0.6-0.8,0.8c-0.3,0-3,0.3-3,0.3C266.6,8,266.4,8,266.4,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-218",
    className: "st142",
    d: "M266.4,7.5c0,0.3,0.3-2.2,0.6-2.2c0-0.3,0.6-0.6,0.8-0.6s3-0.3,3-0.3c0.3,0,0.8,0.3,0.8,0.6 c0-0.3-0.3,2.2-0.6,2.2c0,0.3-0.6,0.6-0.8,0.6s-3,0.3-3,0.3C266.6,8,266.4,7.7,266.4,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-219",
    className: "st143",
    d: "M266.4,7.5c0,0.3,0.3-2.2,0.6-2.2c0-0.3,0.6-0.6,0.8-0.6s3-0.3,3-0.3c0.3,0,0.8,0.3,0.8,0.6 c0-0.3-0.3,2.2-0.6,2.2c0,0.3-0.6,0.6-0.8,0.6s-3,0.3-3,0.3C266.6,8,266.4,7.7,266.4,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-220",
    className: "st144",
    d: "M266.4,7.5c0,0.3,0.3-2.2,0.6-2.2c0-0.3,0.6-0.6,0.8-0.6s3-0.3,3-0.3c0.3,0,0.8,0.3,0.8,0.6 c0-0.3-0.3,2.2-0.6,2.2c0,0.3-0.6,0.6-0.8,0.6s-3,0.3-3,0.3C266.6,8,266.4,7.7,266.4,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-221",
    className: "st1",
    d: "M266.4,7.5c0,0.3,0.3-2.2,0.6-2.2c0-0.3,0.6-0.6,0.8-0.6s3-0.3,3-0.3c0.3,0,0.8,0.3,0.8,0.6 c0-0.3-0.3,2.2-0.6,2.2c0,0.3-0.6,0.6-0.8,0.6s-3,0.3-3,0.3C266.6,8,266.4,7.7,266.4,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-222",
    className: "st145",
    d: "M266.4,7.5c0,0.3,0.3-2.2,0.6-2.2c0-0.3,0.6-0.6,0.8-0.6s3-0.3,3-0.3c0.3,0,0.8,0.3,0.8,0.6 c0-0.3-0.3,2.2-0.6,2.2c0,0.3-0.6,0.6-0.8,0.6s-3,0.3-3,0.3C266.6,8,266.4,7.7,266.4,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-223",
    className: "st146",
    d: "M266.4,7.5c0,0.3,0.3-2.2,0.6-2.2c0-0.3,0.6-0.6,0.8-0.6s3-0.3,3-0.3c0.3,0,0.8,0.3,0.8,0.6 c0-0.3-0.3,2.2-0.6,2.2c0,0.3-0.6,0.6-0.8,0.6s-3,0.3-3,0.3C266.6,8,266.4,7.7,266.4,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-224",
    className: "st147",
    d: "M266.4,7.5c0,0.3,0.3-1.9,0.6-1.9c0-0.3,0.6-0.6,0.8-0.6s3-0.3,3-0.3c0.2,0,0.4,0.1,0.6,0.3 c0-0.3-0.3,1.9-0.6,1.9c0,0.3-0.6,0.6-0.8,0.6s-3,0.3-3,0.3C266.6,8,266.4,7.7,266.4,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-225",
    className: "st148",
    d: "M266.4,7.5c0,0.3,0.3-1.9,0.6-1.9c0-0.3,0.6-0.6,0.8-0.6s2.8-0.3,3-0.3s0.4,0.1,0.6,0.3 c0-0.3-0.3,1.9-0.6,1.9c0,0.3-0.6,0.6-0.8,0.6s-2.8,0.3-3,0.3C266.6,8,266.4,7.7,266.4,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-226",
    className: "st148",
    d: "M266.4,7.5c0,0.3,0.3-1.9,0.6-1.9c0-0.3,0.6-0.6,0.8-0.6s2.8-0.3,3-0.3s0.6,0,0.6,0.3 c0-0.3-0.3,1.9-0.6,1.9c0,0.3-0.6,0.6-0.8,0.6s-2.8,0.3-3,0.3C266.6,8,266.4,7.7,266.4,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-227",
    className: "st149",
    d: "M266.4,7.5c0,0.3,0.3-1.9,0.6-1.9c0-0.3,0.6-0.6,0.8-0.6s2.8-0.3,2.8-0.3c0.3,0,0.6,0,0.6,0.3 c0-0.3-0.3,1.9-0.6,1.9c0,0.3-0.6,0.6-0.8,0.6S267,7.8,267,7.8C266.6,8,266.4,7.7,266.4,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-228",
    className: "st149",
    d: "M266.4,7.5c0,0.3,0.3-1.9,0.6-1.9c0-0.3,0.6-0.6,0.8-0.6s2.8-0.3,2.8-0.3c0.3,0,0.6,0,0.6,0.3 c0-0.3-0.3,1.9-0.6,1.9c0,0.3-0.6,0.6-0.8,0.6S267,7.8,267,7.8C266.9,8,266.4,7.7,266.4,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-229",
    className: "st150",
    d: "M266.6,7.5c0,0.3,0.3-1.9,0.6-1.9c0-0.3,0.6-0.6,0.8-0.6s2.8-0.3,2.8-0.3c0.3,0,0.6,0,0.6,0.3 c0-0.3-0.3,1.9-0.6,1.9c0,0.3-0.6,0.6-0.8,0.6s-2.8,0.3-2.8,0.3C266.9,7.7,266.6,7.7,266.6,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-230",
    className: "st150",
    d: "M266.6,7.5c0,0.3,0.3-1.9,0.6-1.9c0-0.3,0.6-0.6,0.8-0.6s2.8-0.3,2.8-0.3c0.3,0,0.6,0,0.6,0.3 c0-0.3-0.3,1.9-0.6,1.9c0,0.3-0.6,0.6-0.8,0.6s-2.8,0.3-2.8,0.3C266.9,7.7,266.6,7.7,266.6,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-231",
    className: "st151",
    d: "M266.6,7.5c0,0.3,0.3-1.9,0.6-1.9c0-0.3,0.6-0.6,0.8-0.6s2.8-0.3,2.8-0.3c0.3,0,0.6,0,0.6,0.3 c0-0.3-0.3,1.9-0.6,1.9c0,0.3-0.6,0.6-0.8,0.6s-2.8,0.3-2.8,0.3C266.9,7.7,266.6,7.7,266.6,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-232",
    className: "st151",
    d: "M266.6,7.5c0,0.3,0.3-1.9,0.6-1.9c0-0.3,0.3-0.6,0.8-0.6c0.3,0,2.8-0.3,2.8-0.3 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.9-0.6,1.9c0,0.3-0.6,0.6-0.8,0.6s-2.8,0.3-2.8,0.3C266.9,7.7,266.6,7.7,266.6,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-233",
    className: "st152",
    d: "M266.6,7.5c0,0.3,0.3-1.7,0.6-1.7c0-0.3,0.3-0.6,0.8-0.6c0.3,0,2.8-0.3,2.8-0.3 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.7-0.6,1.7c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.8,0.3-2.8,0.3C266.9,7.7,266.6,7.7,266.6,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-234",
    className: "st153",
    d: "M266.6,7.5c0,0.3,0.3-1.7,0.6-1.7c0-0.3,0.3-0.6,0.8-0.6c0.3,0,2.8-0.3,2.8-0.3 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.7-0.6,1.7c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.8,0.3-2.8,0.3C267,7.7,266.8,7.6,266.6,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-235",
    className: "st154",
    d: "M266.6,7.5c0,0.3,0.3-1.7,0.6-1.7c0-0.3,0.3-0.6,0.8-0.6c0.3,0,2.8-0.3,2.8-0.3 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.7-0.6,1.7c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.8,0.3-2.8,0.3C267,7.7,266.8,7.6,266.6,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-236",
    className: "st155",
    d: "M266.6,7.5c0,0.3,0.3-1.7,0.6-1.7c0-0.3,0.3-0.6,0.8-0.6c0.3,0,2.5-0.3,2.8-0.3s0.6,0,0.6,0.3 c0-0.3-0.3,1.7-0.6,1.7c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.5,0.3-2.8,0.3C267,7.7,266.8,7.6,266.6,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-237",
    className: "st156",
    d: "M266.6,7.2c0,0.3,0.3-1.7,0.6-1.7c0-0.3,0.3-0.6,0.8-0.6c0.3,0,2.5-0.3,2.8-0.3s0.6,0,0.6,0.3 c0-0.3-0.3,1.7-0.6,1.7c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.5,0.3-2.8,0.3C266.9,7.7,266.6,7.5,266.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-238",
    className: "st157",
    d: "M266.6,7.2c0,0.3,0.3-1.7,0.6-1.7c0-0.3,0.3-0.6,0.8-0.6c0.3,0,2.5-0.3,2.5-0.3 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.7-0.6,1.7c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.5,0.3-2.5,0.3C266.9,7.7,266.6,7.5,266.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-239",
    className: "st158",
    d: "M266.6,7.2c0,0.3,0.3-1.7,0.6-1.7c0-0.3,0.3-0.6,0.8-0.6c0.3,0,2.5-0.3,2.5-0.3 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.7-0.6,1.7c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.5,0.3-2.5,0.3C266.9,7.7,266.6,7.5,266.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-240",
    className: "st159",
    d: "M266.6,7.2c0,0.3,0.3-1.7,0.6-1.7c0-0.3,0.3-0.6,0.8-0.6c0.3,0,2.5-0.3,2.5-0.3 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.7-0.6,1.7c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.5,0.3-2.5,0.3C266.9,7.7,266.6,7.5,266.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-241",
    className: "st160",
    d: "M266.6,7.2c0,0.3,0.3-1.7,0.6-1.7c0-0.3,0.3-0.6,0.8-0.6c0.3,0,2.5-0.3,2.5-0.3 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.7-0.6,1.7c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.5,0.3-2.5,0.3C266.9,7.7,266.6,7.5,266.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-242",
    className: "st161",
    d: "M266.6,7.2c0,0.3,0.3-1.4,0.6-1.4c0-0.3,0.3-0.6,0.8-0.6c0.3,0,2.5-0.3,2.5-0.3 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.4-0.6,1.4c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.5,0.3-2.5,0.3C266.9,7.5,266.6,7.5,266.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-243",
    className: "st162",
    d: "M266.6,7.2c0,0.3,0.3-1.4,0.6-1.4c0-0.3,0.3-0.6,0.8-0.6c0.3,0,2.5-0.3,2.5-0.3 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.4-0.6,1.4c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.5,0.3-2.5,0.3C266.9,7.5,266.6,7.5,266.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-244",
    className: "st163",
    d: "M266.6,7.2c0,0.3,0.3-1.4,0.6-1.4c0-0.3,0.3-0.6,0.8-0.6c0.3,0,2.5-0.3,2.5-0.3 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.4-0.6,1.4c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.5,0.3-2.5,0.3C266.9,7.5,266.6,7.5,266.6,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-245",
    className: "st163",
    d: "M266.9,7.2c0,0.3,0.3-1.4,0.6-1.4c0-0.3,0.3-0.6,0.8-0.6c0.3,0,2.5-0.3,2.5-0.3 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.4-0.6,1.4c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.5,0.3-2.5,0.3C266.9,7.5,266.9,7.5,266.9,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-246",
    className: "st164",
    d: "M266.9,7.2c0,0.3,0.3-1.4,0.6-1.4c0-0.3,0.3-0.6,0.8-0.6c0.3,0,2.5-0.3,2.5-0.3 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.4-0.6,1.4c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.5,0.3-2.5,0.3C266.9,7.5,266.9,7.5,266.9,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-247",
    className: "st165",
    d: "M266.9,7.2c0,0.3,0.3-1.4,0.6-1.4c0-0.3,0.3-0.6,0.8-0.6c0.3,0,2.2-0.3,2.5-0.3s0.6,0,0.6,0.3 c0-0.3-0.3,1.4-0.6,1.4c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.2,0.3-2.5,0.3C266.9,7.5,266.9,7.5,266.9,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-248",
    className: "st166",
    d: "M266.9,7.2c0,0.3,0.3-1.4,0.6-1.4c0-0.3,0.3-0.6,0.8-0.6c0.3,0,2.2-0.3,2.5-0.3s0.6,0,0.6,0.3 c0-0.3-0.3,1.4-0.6,1.4c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.2,0.3-2.5,0.3S266.9,7.5,266.9,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-249",
    className: "st167",
    d: "M266.9,7.2c0,0.3,0.3-1.4,0.6-1.4c0-0.3,0.3-0.6,0.8-0.6c0.3,0,2.2-0.3,2.2-0.6 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.4-0.6,1.4c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.2,0.3-2.2,0.6C267.3,7.4,267.1,7.3,266.9,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-250",
    className: "st168",
    d: "M266.9,7.2c0,0.3,0.3-1.4,0.6-1.4c0-0.3,0.3-0.6,0.8-0.6c0.3,0,2.2-0.3,2.2-0.6 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.4-0.6,1.4c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.2,0.3-2.2,0.6C267.3,7.4,267.1,7.3,266.9,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-251",
    className: "st169",
    d: "M266.9,7.2c0,0.3,0.3-1.1,0.8-1.1c0-0.6,0.3-0.6,0.6-0.6s2.2-0.3,2.2-0.6c0.3,0,0.6,0,0.6,0.3 c0-0.3-0.3,1.1-0.8,1.1c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.2,0.3-2.2,0.6L266.9,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-252",
    className: "st170",
    d: "M266.9,7.2c0,0.3,0.3-1.1,0.8-1.1c0-0.6,0.3-0.6,0.6-0.6s2.2-0.3,2.2-0.6c0.3,0,0.6,0,0.6,0.3 c0-0.3-0.3,1.1-0.8,1.1c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.2,0.3-2.2,0.6L266.9,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-253",
    className: "st171",
    d: "M266.9,7.2c0,0.3,0.3-1.1,0.8-1.1c0-0.3,0.3-0.5,0.6-0.6c0.3,0,2.2-0.3,2.2-0.6 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.1-0.8,1.1c0,0.3-0.3,0.6-0.8,0.6c-0.3,0-2.2,0.3-2.2,0.6L266.9,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-254",
    className: "st172",
    d: "M266.9,7.2c0,0.3,0.3-1.1,0.8-1.1c0-0.3,0.3-0.5,0.6-0.6c0.3,0,2.2-0.3,2.2-0.6 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.1-0.8,1.1c0,0.3-0.3,0.5-0.6,0.6c-0.3,0-2.2,0.3-2.2,0.6C267.3,7.4,267.1,7.3,266.9,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-255",
    className: "st173",
    d: "M266.9,7.2c0,0.3,0.3-1.1,0.8-1.1c0-0.3,0.3-0.5,0.6-0.6c0.3,0,2.2-0.3,2.2-0.6 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.1-0.8,1.1c0,0.3-0.3,0.5-0.6,0.6c-0.3,0-2.2,0.3-2.2,0.6C267.3,7.4,267.1,7.3,266.9,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-256",
    className: "st173",
    d: "M266.9,7.2c0,0.3,0.3-1.1,0.8-1.1c0-0.3,0.3-0.5,0.6-0.6c0.3,0,2.2-0.3,2.2-0.6 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.1-0.8,1.1c0,0.3-0.3,0.5-0.6,0.6c-0.3,0-2.2,0.3-2.2,0.6C267.3,7.3,267.1,7.2,266.9,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-257",
    className: "st174",
    d: "M266.9,6.9c0,0.3,0.3-1.1,0.8-1.1c0-0.3,0.3-0.5,0.6-0.6c0.3,0,2.2-0.3,2.2-0.6 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.1-0.8,1.1c0,0.3-0.3,0.5-0.6,0.6c-0.3,0-2.2,0.3-2.2,0.6C267.2,7.2,266.9,7.2,266.9,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-258",
    className: "st174",
    d: "M266.9,6.9c0,0.3,0.3-1.1,0.8-1.1c0-0.3,0.3-0.5,0.6-0.6c0.8-0.1,1.5-0.2,2.2-0.6 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.1-0.8,1.1c0,0.3-0.3,0.5-0.6,0.6c-0.8,0.1-1.5,0.2-2.2,0.6C267.2,7.2,266.9,7.2,266.9,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-259",
    className: "st175",
    d: "M266.9,6.9c0,0.3,0.3-1.1,0.8-1.1c0-0.3,0.3-0.3,0.6-0.6c0.8-0.1,1.5-0.2,2.2-0.6 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,1.1-0.8,1.1c0,0.3-0.3,0.3-0.6,0.6c-0.8,0.1-1.5,0.2-2.2,0.6C267.2,7.2,266.9,7.2,266.9,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-260",
    className: "st176",
    d: "M266.9,6.9c0,0.3,0.3-0.8,0.8-0.8c0-0.3,0.3-0.3,0.6-0.6c0.8-0.1,1.5-0.2,2.2-0.6 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,0.8-0.8,0.8c0,0.3-0.3,0.3-0.6,0.6c-0.3,0-1.9,0.3-1.9,0.6C267.2,7.2,266.9,7.2,266.9,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-261",
    className: "st177",
    d: "M266.9,6.9c0,0.3,0.3-0.8,0.8-0.8c0-0.3,0.3-0.3,0.6-0.6c0.3,0,1.9-0.3,1.9-0.6 c0.3,0,0.6,0,0.6,0.3c0-0.3-0.3,0.8-0.8,0.8c0,0.3-0.3,0.3-0.6,0.6c-0.3,0-1.9,0.3-1.9,0.6C267.2,7.2,266.9,7.2,266.9,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-262",
    className: "st178",
    d: "M267.2,6.9c0,0.3,0.3-0.8,0.8-0.8c0-0.3,0.3-0.3,0.6-0.6c0.3,0,1.9-0.3,1.9-0.6h0.6 c0-0.3-0.3,0.8-0.8,0.8c0,0.3-0.3,0.3-0.6,0.6c-0.3,0-1.9,0.3-1.9,0.6C267.2,7.2,267.2,7.2,267.2,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-263",
    className: "st179",
    d: "M267.2,6.9c0,0.3,0.3-0.8,0.8-0.8c0-0.3,0.3-0.3,0.6-0.3s1.9-0.3,1.9-0.6h0.6 c0-0.3-0.3,0.8-0.8,0.8c0,0.3-0.3,0.3-0.6,0.3s-1.9,0.3-1.9,0.6C267.2,7.2,267.2,7.2,267.2,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-264",
    className: "st180",
    d: "M267.2,6.9c0,0.3,0.3-0.8,0.8-0.8c0-0.3,0.3-0.3,0.6-0.3s1.9-0.3,1.9-0.6h0.6 c0-0.3-0.3,0.8-0.8,0.8c0,0.3-0.3,0.3-0.6,0.3s-1.9,0.3-1.9,0.6C267.2,7.2,267.2,7.2,267.2,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-265",
    className: "st181",
    d: "M267.2,6.9c0,0.3,0.3-0.8,0.8-0.8c0-0.3,0.3-0.3,0.6-0.3s1.9-0.3,1.9-0.6h0.6 c0-0.3-0.3,0.8-0.8,0.8c0,0.3-0.3,0.3-0.6,0.3s-1.9,0.3-1.9,0.6C267.2,7.2,267.2,6.9,267.2,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-266",
    className: "st182",
    d: "M267.2,6.9c0,0.3,0.3-0.8,0.8-0.8c0-0.3,0.3-0.3,0.6-0.3s1.9-0.3,1.9-0.6h0.3 c0-0.3-0.3,0.8-0.8,0.8c0,0.3-0.3,0.3-0.6,0.3s-1.9,0.3-1.9,0.6C267.2,7.2,267.2,6.9,267.2,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-267",
    className: "st183",
    d: "M267.2,6.9c0,0.3,0.3-0.8,0.8-0.8c0-0.3,0.3-0.3,0.6-0.3s1.9-0.3,1.9-0.6h0.3 c0-0.3-0.3,0.8-0.8,0.8c0,0.3-0.3,0.3-0.6,0.3s-1.9,0.3-1.9,0.6S267.2,6.9,267.2,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-268",
    className: "st184",
    d: "M267.2,6.9c0,0.3,0.3-0.8,0.8-0.8c0-0.3,0.3-0.3,0.6-0.3s1.9-0.3,1.9-0.6h0.3 c0-0.3-0.3,0.8-0.8,0.8c0,0.3-0.3,0.3-0.6,0.3s-1.9,0.3-1.9,0.6S267.2,6.9,267.2,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-269",
    className: "st185",
    d: "M267.2,6.9c0,0.3,0.3-0.6,0.8-0.6c0-0.3,0.3-0.3,0.6-0.3c0.7-0.1,1.3-0.2,1.9-0.6h0.3 c0-0.3-0.3,0.6-0.8,0.6c0,0.3-0.3,0.3-0.6,0.3c-0.7,0.1-1.3,0.2-1.9,0.6H267.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-270",
    className: "st186",
    d: "M267.2,6.9c0,0.3,0.3-0.6,0.8-0.6c0-0.3,0.3-0.3,0.6-0.3c0.7-0.1,1.3-0.2,1.9-0.6h0.3 c0-0.3-0.3,0.6-0.8,0.6c0,0.3-0.3,0.3-0.6,0.3c-0.7,0.1-1.3,0.2-1.9,0.6H267.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-271",
    className: "st187",
    d: "M267.2,6.9c0,0.3,0.3-0.6,0.8-0.6c0-0.3,0.3-0.3,0.6-0.3c0.5-0.3,1.1-0.5,1.7-0.6h0.3 c0-0.3-0.3,0.6-0.8,0.6c0,0.3-0.3,0.3-0.6,0.3C268.5,6.4,267.8,6.6,267.2,6.9L267.2,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-272",
    className: "st188",
    d: "M267.2,6.9c0,0.6,0.3-0.6,0.8-0.6c0-0.3,0.3-0.3,0.6-0.3c0.5-0.3,1.1-0.5,1.7-0.6h0.3 c0-0.6-0.3,0.6-0.8,0.6c0,0.3-0.3,0.3-0.6,0.3s-1.7,0.3-1.7,0.6H267.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-273",
    className: "st189",
    d: "M267.2,6.9c0,0.6,0.3-0.6,0.8-0.6c0-0.3,0.3-0.3,0.6-0.3c0.5-0.3,1.1-0.5,1.7-0.6h0.3 c0-0.6-0.3,0.6-0.8,0.6c0,0.3-0.3,0.3-0.6,0.3s-1.7,0.3-1.7,0.6H267.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-274",
    className: "st190",
    d: "M267.2,6.9c0,0.6,0.3-0.6,0.8-0.6c0-0.3,0.3-0.3,0.6-0.3s1.7-0.3,1.7-0.6h0.3 c0-0.6-0.3,0.6-0.8,0.6c0,0.3-0.3,0.3-0.6,0.3s-1.7,0.3-1.7,0.6H267.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-275",
    className: "st191",
    d: "M267.2,6.9c0,0.6,0.3-0.6,0.8-0.6c0-0.3,0.3-0.3,0.6-0.3s1.7-0.3,1.7-0.6h0.3 c0-0.6-0.3,0.6-0.8,0.6c0,0.3-0.3,0.3-0.6,0.3s-1.7,0.3-1.7,0.6H267.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-276",
    className: "st192",
    d: "M267.2,6.9c0,0.6,0.3-0.6,0.8-0.6c0-0.3,0.3-0.3,0.6-0.3s1.7-0.3,1.7-0.6h0.3 c0-0.6-0.3,0.6-0.8,0.6c0,0.3-0.3,0.3-0.6,0.3s-1.7,0.3-1.7,0.6H267.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-277",
    className: "st192",
    d: "M267.2,6.6c0,0.6,0.3-0.6,0.8-0.6c0-0.3,0.3-0.3,0.6-0.3s1.7-0.3,1.7-0.6h0.3 c0-0.6-0.3,0.6-0.8,0.6c0,0.3-0.3,0.3-0.6,0.3s-1.7,0.3-1.7,0.6S267.2,6.9,267.2,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-278",
    className: "st193",
    d: "M267.5,6.6c0,0.6,0.3-0.3,0.8-0.3c0-0.3,0.3-0.3,0.6-0.3s1.7-0.3,1.7-0.6h0.3 c0-0.6-0.3,0.3-0.8,0.3c0,0.3-0.3,0.3-0.6,0.3s-1.7,0.3-1.7,0.6C267.5,6.9,267.5,6.9,267.5,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-279",
    className: "st193",
    d: "M267.5,6.6c0,0.6,0.3-0.3,0.8-0.3c0-0.3,0.3-0.3,0.6-0.3c0.6-0.1,1.2-0.2,1.7-0.6h0.3 c0-0.6-0.3,0.3-0.8,0.3c0,0.3-0.3,0.3-0.6,0.3c-0.6,0.1-1.2,0.2-1.7,0.6C267.5,6.9,267.5,6.9,267.5,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-280",
    className: "st194",
    d: "M267.5,6.6c0,0.6,0.3-0.3,0.8-0.3c0-0.3,0.3-0.3,0.6-0.3c0.6-0.1,1.2-0.2,1.7-0.6h0.3 c0-0.6-0.3,0.3-0.8,0.3c0,0.3-0.3,0.3-0.6,0.3c-0.6,0.1-1.2,0.2-1.7,0.6C267.5,6.9,267.5,6.9,267.5,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-281",
    className: "st194",
    d: "M267.5,6.6c0,0.6,0.3-0.3,0.8-0.3c0-0.3,0.3-0.3,0.6-0.3c0.6-0.1,1.2-0.2,1.7-0.6h0.3 c0-0.6-0.3,0.3-0.8,0.3c0,0.3-0.3,0.3-0.6,0.3c-0.6,0.1-1.2,0.2-1.7,0.6C267.5,6.9,267.5,6.6,267.5,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-282",
    className: "st195",
    d: "M267.5,6.6c0,0.6,0.3-0.3,0.8-0.3c0.1-0.2,0.3-0.2,0.6-0.3c0.6-0.1,1.2-0.2,1.7-0.6h0.3 c0-0.6-0.3,0.3-0.8,0.3c-0.1,0.2-0.3,0.2-0.6,0.3c-0.6,0.1-1.2,0.2-1.7,0.6H267.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-283",
    className: "st196",
    d: "M267.5,6.6c0,0.6,0.3-0.3,0.8-0.3c0.1-0.2,0.3-0.2,0.6-0.3c0.3,0,1.4-0.3,1.4-0.6h0.3 c0-0.6-0.3,0.3-0.8,0.3c-0.1,0.2-0.3,0.2-0.6,0.3c-0.3,0-1.4,0.3-1.4,0.6H267.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-284",
    className: "st197",
    d: "M267.5,6.6c0,0.6,0.3-0.3,0.8-0.3c0.1-0.2,0.3-0.2,0.6-0.3c0.3,0,1.4-0.3,1.4-0.6h0.3 c0-0.6-0.3,0.3-0.8,0.3c-0.1,0.2-0.3,0.2-0.6,0.3c-0.3,0-1.4,0.3-1.4,0.6H267.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-285",
    className: "st198",
    d: "M267.5,6.6c0,0.6,0.3-0.3,0.8-0.3c0.1-0.2,0.3-0.2,0.6-0.3c0.3,0,1.4-0.3,1.4-0.6h0.3 c0-0.6-0.3,0.3-0.8,0.3c-0.1,0.2-0.3,0.2-0.6,0.3c-0.3,0-1.4,0.3-1.4,0.6H267.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-286",
    className: "st198",
    d: "M267.5,6.6c0,0.6,0.3-0.3,0.8-0.3c0.1-0.2,0.3-0.2,0.6-0.3c0.3,0,1.4-0.3,1.4-0.6h0.3 c0-0.6-0.3,0.3-0.8,0.3c-0.1,0.2-0.3,0.2-0.6,0.3c-0.3,0-1.4,0.3-1.4,0.6H267.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-287",
    className: "st199",
    d: "M267.5,6.6c0,0.6,0.3,0,0.8,0c0.1-0.2,0.3-0.2,0.6-0.3c0.3,0,1.4-0.3,1.4-0.6h0.3 c0-0.6-0.3,0-0.8,0c-0.1,0.2-0.3,0.2-0.6,0.3C268.5,6.1,268,6.3,267.5,6.6L267.5,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-288",
    className: "st199",
    d: "M267.5,6.6c0,0.6,0.3,0,0.8,0c0.1-0.2,0.3-0.2,0.6-0.3c0.3,0,1.4-0.3,1.4-0.6h0.3 c0-0.6-0.3,0-0.8,0c-0.1,0.2-0.3,0.2-0.6,0.3C268.5,6.1,268,6.3,267.5,6.6L267.5,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-289",
    className: "st200",
    d: "M267.5,6.6c0,0.6,0.3,0,0.8,0c0.1-0.2,0.3-0.2,0.6-0.3c0.3,0,1.4-0.3,1.4-0.6h0.3 c0-0.6-0.3,0-0.8,0c-0.1,0.2-0.3,0.2-0.6,0.3C268.5,6.1,268,6.3,267.5,6.6L267.5,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-290",
    className: "st201",
    d: "M267.5,6.6c0,0.6,0.3,0,0.8,0c0.1-0.2,0.3-0.2,0.6-0.3c0.5-0.1,1-0.3,1.4-0.6h0.3 c0-0.6-0.3,0-0.8,0c-0.1,0.2-0.3,0.2-0.6,0.3C268.6,6.2,268,6.4,267.5,6.6L267.5,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-291",
    className: "st202",
    d: "M267.5,6.6c0,0.6,0.3,0,0.8,0c0.1-0.2,0.3-0.2,0.6-0.3c0.5-0.1,1-0.3,1.4-0.6h0.3 c0-0.6-0.3,0-0.8,0c-0.1,0.2-0.3,0.2-0.6,0.3C268.6,6.2,268,6.4,267.5,6.6L267.5,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-292",
    className: "st203",
    d: "M267.5,6.6c0,0.6,0.3,0,0.8,0c0.1-0.2,0.3-0.2,0.6-0.3c0.5-0.1,1-0.3,1.4-0.6h0.3 c0-0.6-0.3,0-0.8,0c-0.1,0.2-0.3,0.2-0.6,0.3C268.6,6.2,268,6.4,267.5,6.6L267.5,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-293",
    className: "st204",
    d: "M267.5,6.6c0,0.6,0.3,0,0.8,0c0.1-0.2,0.3-0.2,0.6-0.3c0.5-0.1,1-0.3,1.4-0.6h0.3 c0-0.6-0.3,0-0.8,0c-0.1,0.2-0.3,0.2-0.6,0.3C268.6,6.2,268,6.4,267.5,6.6L267.5,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-294",
    className: "st205",
    d: "M267.8,6.6c0,0.6,0.3,0,0.8,0c0.1-0.2,0.3-0.2,0.6-0.3c0.3,0,1.1-0.3,1.1-0.6h0.3 c0-0.6-0.3,0-0.8,0c-0.1,0.2-0.3,0.2-0.6,0.3C268.9,6.1,268,6.1,267.8,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-295",
    className: "st206",
    d: "M267.8,6.6c0,0.6,0.3,0,0.8,0c0.1-0.2,0.3-0.2,0.6-0.3c0.3,0,1.1-0.3,1.1-0.6h0.3 c0-0.6-0.3,0-0.8,0c-0.1,0.2-0.3,0.2-0.6,0.3C268.9,6.1,268,6.1,267.8,6.6L267.8,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-296",
    className: "st207",
    d: "M267.8,6.6c0,0.6,0.3,0.3,0.8,0.3c0.1-0.2,0.3-0.2,0.6-0.3c0.3,0,1.1-0.3,1.1-0.6h0.3 c0-0.6-0.3-0.3-0.8-0.3c-0.1,0.2-0.3,0.2-0.6,0.3C268.9,6.1,268,6.1,267.8,6.6L267.8,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-297",
    className: "st208",
    d: "M267.8,6.3c0,0.6,0.3,0.3,0.8,0.3c0.1-0.2,0.3-0.2,0.6-0.3c0.3,0,1.1-0.3,1.1-0.6h0.3 c0-0.6-0.3-0.3-0.8-0.3c-0.1,0.2-0.3,0.2-0.6,0.3C268.9,6.1,268,6.1,267.8,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-298",
    className: "st209",
    d: "M267.8,6.3c0,0.6,0.3,0.3,0.8,0.3c0.1-0.2,0.3-0.2,0.6-0.3c0.3,0,1.1-0.3,1.1-0.6h0.3 c0-0.6-0.3-0.3-0.8-0.3c-0.1,0.2-0.3,0.2-0.6,0.3C268.6,5.9,268.2,6,267.8,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-299",
    className: "st210",
    d: "M267.8,6.3c0,0.6,0.3,0.3,0.8,0.3c0.1-0.2,0.3-0.2,0.6-0.3c0.3,0,1.1-0.3,1.1-0.6 c0.1,0,0.3-0.1,0.3-0.3l0,0h-1.1c-0.1,0.2-0.3,0.2-0.6,0.3C268.5,5.9,268.1,6.1,267.8,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-300",
    className: "st211",
    d: "M267.8,6.3c0,0.6,0.3,0.3,0.8,0.3c0.1-0.2,0.3-0.2,0.6-0.3c0.3,0,1.1-0.3,1.1-0.6 c0.1,0,0.3-0.1,0.3-0.3l0,0h-1.1c-0.1,0.2-0.3,0.2-0.6,0.3C268.5,5.9,268.1,6.1,267.8,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-301",
    className: "st212",
    d: "M267.8,6.3c0,0.6,0.3,0.3,0.8,0.3c0.1-0.2,0.3-0.2,0.6-0.3c0.4-0.1,0.8-0.3,1.1-0.6 c0.1,0,0.3-0.1,0.3-0.3l0,0h-1.1c-0.1,0.2-0.3,0.2-0.6,0.3C268.5,5.9,268.1,6.1,267.8,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-302",
    className: "st213",
    d: "M267.8,6.3c0,0.6,0.3,0.3,0.8,0.3c0.1,0,0.3-0.1,0.3-0.3l0,0c0.4-0.1,0.8-0.3,1.1-0.6 c0.1,0,0.3-0.1,0.3-0.3l0,0h-0.8c-0.1,0-0.3,0.1-0.3,0.3l0,0C268.6,5.9,268.2,6,267.8,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-303",
    className: "st214",
    d: "M267.8,6.3c0,0.6,0.3,0.3,0.8,0.3c0.1,0,0.3-0.1,0.3-0.3l0,0c0.4-0.1,0.8-0.3,1.1-0.6 c0.1,0,0.3-0.1,0.3-0.3l0,0h-0.8c-0.1,0-0.3,0.1-0.3,0.3l0,0C268.6,5.8,268.1,6,267.8,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-304",
    className: "st215",
    d: "M267.8,6.3c0,0.6,0.3,0.3,0.8,0.3c0.1,0,0.3-0.1,0.3-0.3l0,0c0.4-0.1,0.8-0.3,1.1-0.6 c0.1,0,0.3-0.1,0.3-0.3l0,0h-0.8c-0.1,0-0.3,0.1-0.3,0.3l0,0C268.6,5.8,268.1,6,267.8,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-305",
    className: "st215",
    d: "M267.8,6.3c0,0.6,0.3,0.3,0.8,0.3c0.1,0,0.3-0.1,0.3-0.3l0,0c0.3,0,0.8-0.3,0.8-0.6l0.3-0.3 h-0.6c-0.1,0-0.3,0.1-0.3,0.3l0,0C268.6,5.8,268.1,6,267.8,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-306",
    className: "st216",
    d: "M267.8,6.3c0,0.6,0.3,0.6,0.8,0.6c0.1,0,0.3-0.1,0.3-0.3l0,0c0.3,0,0.8-0.3,0.8-0.6l0.3-0.3 c0.3-0.3-0.3-0.3-0.5-0.3c-0.1,0-0.3,0.1-0.3,0.3l0,0C268.6,5.8,268,5.8,267.8,6.3L267.8,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-307",
    className: "st216",
    d: "M267.8,6.3c0,0.6,0.3,0.6,0.8,0.6c0.1,0,0.3-0.1,0.3-0.3l0,0c0.3,0,0.8-0.3,0.8-0.6l0.3-0.3 c0.3-0.3-0.3-0.3-0.8-0.3c-0.1,0-0.3,0.1-0.3,0.3l0,0C268.4,5.7,268,6,267.8,6.3L267.8,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-308",
    className: "st217",
    d: "M267.8,6.3c0,0.6,0.3,0.6,0.8,0.6h0.3c0.3,0,0.8-0.3,0.8-0.6V6.1c0.6-0.6,0-0.6-0.5-0.6h-0.3 C268.6,5.8,268,5.8,267.8,6.3L267.8,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-309",
    className: "st217",
    d: "M267.8,6.3c0,0.6,0.3,0.6,0.8,0.6h0.3c0.3,0,0.8-0.3,0.8-0.6V6.1c0.3-0.6,0-0.6-0.5-0.6h-0.3 C268.6,5.8,268,5.8,267.8,6.3L267.8,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-310",
    className: "st218",
    d: "M268,6.3c0,0.6,0.3,0.6,0.8,0.6h0.3c0.3,0,0.8-0.3,0.8-0.6V6.1c0-0.6-0.3-0.6-0.8-0.6h-0.3 C268.4,5.5,268.1,5.9,268,6.3L268,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-311",
    className: "st219",
    d: "M268,6.3c0,0.6,0.3,0.6,0.8,0.6h0.3c0.3,0,0.8-0.3,0.8-0.6V6.1c0-0.6-0.3-0.6-0.8-0.6h-0.3 C268.4,5.5,268.1,5.9,268,6.3L268,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-312",
    className: "st220",
    d: "M268,6.3c0,0.6,0.3,0.6,0.8,0.6h0.3c0.3,0,0.6-0.3,0.8-0.6V6.1c0-0.6-0.3-0.6-0.8-0.6h-0.3 C268.4,5.5,268.1,5.9,268,6.3L268,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-313",
    className: "st221",
    d: "M268,6.3c0,0.6,0.3,0.6,0.8,0.6h0.3c0.3,0,0.6-0.3,0.8-0.6V6.1c0-0.6-0.3-0.6-0.8-0.6h-0.3 C268.4,5.5,268.1,5.9,268,6.3L268,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-314",
    className: "st222",
    d: "M268,6.3c0,0.6,0.3,0.6,0.8,0.6h0.3c0.3,0,0.6-0.3,0.8-0.6V6.1c0-0.6-0.3-0.6-0.8-0.6h-0.3 C268.4,5.5,268.1,5.9,268,6.3L268,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-315",
    className: "st223",
    d: "M268,6.3c-0.1,0.4,0.2,0.8,0.6,0.8c0.1,0,0.1,0,0.2,0h0.3c0.3,0,0.6-0.3,0.8-0.6V6.3 c0.1-0.4-0.2-0.8-0.6-0.8c-0.1,0-0.1,0-0.2,0h-0.3C268.4,5.5,268.1,5.9,268,6.3L268,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-316",
    className: "st224",
    d: "M268,6.3c-0.1,0.4,0.2,0.8,0.6,0.8c0.1,0,0.1,0,0.2,0h0.3c0.3,0,0.5-0.3,0.6-0.6V6.3 c0.1-0.4-0.2-0.8-0.6-0.8c-0.1,0-0.1,0-0.2,0h-0.3C268.4,5.8,268.2,6,268,6.3L268,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-317",
    className: "st225",
    d: "M268,6.1c-0.1,0.4,0.2,0.8,0.6,0.8c0.1,0,0.1,0,0.2,0h0.3c0.3,0,0.5-0.3,0.6-0.6V6.1 c0.1-0.4-0.2-0.8-0.6-0.8c-0.1,0-0.1,0-0.2,0h-0.3C268.6,5.5,268.3,5.8,268,6.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-318",
    className: "st226",
    d: "M268,6.1c-0.1,0.4,0.2,0.8,0.6,0.8c0.1,0,0.1,0,0.2,0h0.3c0.3,0,0.5-0.3,0.6-0.6V6.1 c0.1-0.4-0.2-0.8-0.6-0.8c-0.1,0-0.1,0-0.2,0h-0.3c-0.3,0-0.5,0.3-0.6,0.6V6.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-319",
    className: "st227",
    d: "M268,6.1c-0.1,0.4,0.2,0.8,0.6,0.8c0.1,0,0.1,0,0.2,0h0.3c0.3,0,0.5-0.3,0.6-0.6V6.1 c0.1-0.4-0.2-0.8-0.6-0.8c-0.1,0-0.1,0-0.2,0h-0.3c-0.3,0-0.5,0.3-0.6,0.6V6.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-320",
    className: "st227",
    d: "M268,6.1c-0.1,0.4,0.2,0.8,0.6,0.8c0.1,0,0.1,0,0.2,0h0.3c0.3,0,0.5-0.3,0.6-0.6V6.1 c0.1-0.4-0.2-0.8-0.6-0.8c-0.1,0-0.1,0-0.2,0h-0.3c-0.3,0-0.5,0.3-0.6,0.6V6.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-321",
    className: "st2",
    d: "M270,6.1c0,0.5-0.4,0.8-0.8,0.8c-0.5,0-0.8-0.4-0.8-0.8c-0.1-0.4,0.2-0.8,0.6-0.8 c0.1,0,0.1,0,0.2,0C269.6,5.3,269.9,5.6,270,6.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuerbetLogo);
export default __webpack_public_path__ + "static/media/guerbet-logo.2cac3c2484d64f36fff2a2c3e8028a01.svg";
export { ForwardRef as ReactComponent };